import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useAuth} from "oidc-react";
import {jwtDecode} from "jwt-decode";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import atob from "atob";
import SEO from "../../../components/SEO"
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import PDFJSWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";
import {zoomPlugin} from "@react-pdf-viewer/zoom";
import {pageNavigationPlugin} from "@react-pdf-viewer/page-navigation";
import {findItem, getKeyValue} from '../../../utils/kvp.utils';
import ConfidenceLabel from '../../../components/Labels/Confidence/index.js';
import FileViewer from "../../../components/Viewer/FileViewer/index.js";
import {
    Badge,
    Button,
    Checkbox,
    Collapse,
    DatePicker,
    Empty,
    Input,
    Menu,
    message,
    Modal,
    notification,
    Popover,
    Select,
    Spin,
    Switch,
    Tooltip
} from "antd";

import dayjs from "dayjs";
import "dayjs/locale/en";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";
import "./InvoiceDetail.css";
import {
    BankOutlined,
    CheckCircleOutlined,
    CheckOutlined,
    CloseCircleOutlined,
    CloseOutlined,
    CommentOutlined,
    DeleteOutlined,
    DownCircleOutlined,
    EllipsisOutlined,
    FileTextOutlined,
    FullscreenExitOutlined,
    FullscreenOutlined,
    InfoCircleOutlined,
    LockOutlined,
    PlusOutlined,
    ReloadOutlined,
    SearchOutlined,
    WarningOutlined
} from "@ant-design/icons";

import {thumbnailPlugin} from "@react-pdf-viewer/thumbnail";

import InvoiceHeader from "../../../components/InvoiceHeader";
import BankVerify from "../../../assets/Images/Bank-Verify.png";
import PurchasePopup from "../../../components/popups/PurchasePopup";
import CrewRecoveryPopup from "../../../components/popups/CrewRecoveryPopup/index.js";
import RejectPopUp from "../../../components/popups/RejectPopUp/index.js";
import DeleteInvoicePopup from "../../../components/popups/DeleteInvoicePopup/index.js";
import {typeObject} from "../../../utils/constants.utils.js";
import SupplierDetailsPopup from "../../../components/popups/SupplierDetailsPopup/index.js";
import AddNewBankPopup from "../../../components/popups/AddNewBankPopup/index.js";
import SupplierCurrencyPopup from "../../../components/popups/SupplierCurrencyPopup/index.js";
import {formatDate} from "../../../utils/datetime.utils";
import {convertToBoolean, removeAlphabetsFromString} from "../../../utils/string.utils";
import {convertStringToFloat, safeParseFloat} from "../../../utils/number.utils";
import SharedService from "../../../services/shared/service";
import UpdateInvoiceModal from "../../../components/popups/Invoice/UpdateInvoice/UpdateInvoiceModal";
import ReprocessInvoiceModal from "../../../components/popups/Invoice/ReprocessInvoice/ReprocessInvoiceModal";
import ActionMenu from "../../../components/Menu/Common/InvoiceActionMenu";
import CommentModal from "../../../components/popups/Invoice/Comments/CommentModal";
import {AttachmentType, ProcessingStatusEnum} from "../../../constants/status.constants";
import SupplierOptionCard from "../../../components/Options/Supplier";
import MultiFileUploader from "../../../components/Uploader/MultiFileUploader";
import {convertFileToBase64, getFileMimeType} from "../../../utils/file.utils";
import AttachmentCard from "../../../components/Card/AttachmentCard/AttachmentCard";

const VFC_RESPONSIBILITY_NAME = "Primary Accounting Contact";

dayjs.locale("en");
const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {Panel} = Collapse;

const mockVal = (str, repeat = 1) => ({
    value: str.repeat(repeat),
});

const MismatchIndicator = ({ isMismatch }) => {
    if (isMismatch === true) {
        return (
            <Tooltip title="Mismatch">
                <CloseCircleOutlined
                    style={{ background: "#FFE5E5" }}
                    className="text-[#F1635A] bg-[#FFE5E5] rounded-full text-[22px]"
                />
            </Tooltip>
        );
    }
    if (isMismatch === false) {
        return (
            <Tooltip title="Match">
                <CheckCircleOutlined
                    style={{ background: "#EFFFE5" }}
                    className="text-[#72BA46] rounded-full text-[22px]"
                />
            </Tooltip>
        );
    }
    return null;
};

const pageSEOSettings = {
    title: "Invoice Detail",
};

const InvoiceDetail = ({
                           currentItemIndex,
                           setCurrentItemIndex,
                           invoiceData,
                           setlistPagination,
                           listPagination,
                           setinvoiceData
                       }) => {
    const {
        REACT_APP_SETTINGS_SHOW_SEAFARER_INVOICE,
        REACT_APP_SETTINGS_SHOW_MASTER_AND_OWNERS,
        REACT_APP_SETTINGS_SHOW_MULTI_COMPANY,
        REACT_APP_SETTINGS_SHOW_REPROCESS_BUTTON
    } = process.env;

    const location = useLocation();
    const {state} = location;

    const {pageNumber, radioButton, tableIndex} = state || {};

    const {id} = useParams();

    const [user, setUser] = useState(null);
    const userRef = useRef(null);
    const [companyAllowedCurrencies, setCompanyAllowedCurrencies] = useState([]);
    const [poValidation, setPoValidation] = useState(null);
    const [shipSureIndex, setShipSureIndex] = useState(null);
    const [isOpenArray, setIsOpenArray] = useState([]);
    const [taxItems, setTaxItems] = useState([])
    const [emailData, setEmailData] = useState([]);
    const [supplierDetails, setSupplierDetails] = useState([]);
    const [customerCountryCode, setCustomerCountryCode] = useState("");
    const [taxTypeOptions, setTaxTypeOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [customerloading, setCustomerLoading] = useState(false);
    const [vesselloading, setVesselLoading] = useState(false);
    const [invoiceGetData, setInvoiceGetData] = useState([]);
    const [amountSum, setAmountSum] = useState(0);
    const [recoveryIndexPopup, setRecoveryIndexPopup] = useState(null);
    const [invoiceDetailData, setInvoiceDetailData] = useState([]);
    const [customerType, setCustomerType] = useState("");
    const [isConsolidatedDetailLines, setIsConsolidatedDetailLines] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [crewRecoveryTypeDropdown, setCrewRecoveryTypeDropdown] = useState([]);
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [vesselMgmtBlocked, setVesselMgmtBlocked] = useState(false);
    const [vesselMgmtInfo, setVesselMgmtInfo] = useState(null);
    const lastCheckedCoyIdRef = useRef(null);
    const [disableSave, setDisableSave] = useState(true);
    const [roundValues, setRoundValues] = useState(false);
    const [loading, setloading] = useState(false);
    const [poFlag, setPoFlag] = useState(true);
    const [supplierLoading, setSupplierLoading] = useState(false);
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [isChecked, setChecked] = useState(false);
    const [DocumentTypeOptions, setDocumentTypeOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [financeTaxCodeTypes, setFNTaxCodeIdTypes] = useState([]);
    const [isSupplierPopup, setIsSupplierPopup] = useState(false);
    const [isAddBankPopup, setIsAddBankPopup] = useState(false);
    const [recoveryIndex, setRecoveryIndex] = useState("");
    const [customerAutocomplete, setCustomerAutoComplete] = useState("");
    const [popupVisible, setPopupVisible] = useState(false);
    const [isUpdateInvoiceModalVisible, setIsUpdateInvoiceModalVisible] = useState(false);
    const [isUpdateInvoiceOnHoldModalVisible, setIsUpdateInvoiceOnHoldModalVisible] = useState(false);
    const [isReprocessInvoiceModalVisible, setIsReprocessInvoiceModalVisible] = useState(false);
    const [isCurrencyPopupVisible, setIsCurrencyPopupVisible] = useState(false);
    const [crewRecoveryPopup, setCrewRecoveryPopup] = useState(false);
    const [purchaseOrderList, setPurchaseOrderList] = useState([]);
    const [vesselName, setVesselName] = useState([]);
    const [pdfData, setPdfData] = useState("");
    const [currencyData, setCurrencyData] = useState("");
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [entityType, setEntityType] = useState([]);
    const [shipsureCrewData, setShipsureCrewData] = useState([]);
    const [url, setUrl] = useState("");
    const [file, setFile] = useState(null);
    const [bankDetails, setBankDetails] = useState([]);
    const [popovers, setPopovers] = useState(
        new Array(bankDetails.length).fill(false)
    );
    const [subTotal, setSubTotal] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [totalTax, setTotalTax] = useState(0);
    const [freight, setFreight] = useState(0);
    const [packaging, setPackaging] = useState(0);
    const [invoiceTotal, setInvoiceTotal] = useState(0);
    const [roundedTotal, setRoundedTotal] = useState(0.00);

    // State to manage the icon for each line item
    const [shipsureIcons, setShipsureIcons] = useState(
        Array(bankDetails.length).fill("DownCircleOutlined")
    );

    const [isExpanded, setIsExpanded] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);
    const [allowComments, setAllowComments] = useState(true);
    const [isPopupDeleteVisible, setIsPopupDeleteVisible] = useState(false);
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [isCrewRecovery, setIsCrewRecovery] = useState(false);
    const [supplierOutcome, setSupplierOutcome] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [total, setTotal] = useState("");
    const [urlGenerated, setUrlGenerated] = useState(false);
    const [supplierSearchText, setSupplierSearchText] = useState("");
    const [coyIdPO, setCoyIdPO] = useState("");
    const [isMasterAndOwners, setIsMasterAndOwners] = useState(false);
    const [isMultiCompany, setIsMultiCompany] = useState(false);
    const [isMasterAndOwnersDisabled, setIsMasterAndOwnersDisabled] = useState(true);
    const [selectedRadioOption, setSelectedRadioOption] = useState("");
    const [ocrBankDetails, setOcrBankDetails] = useState([]);
    const [recoveryData, setRecoveryData] = useState([]);
    const [recoveryPcn, setRecoveryPcn] = useState([]);
    const [invoiceType, setInvoiceType] = useState(0);
    const [recoveryVessel, setRecoveryVessel] = useState([]);
    const [recoveryType, setRecoveryType] = useState([]);
    const [bankValues, setBankValues] = useState({
        BankName: "",
        Accountnumber: "",
        SWIFT: "",
        IFSC: "",
        IBAN: "",
        BankCurrencyCode: "",
    });
    const [invoicePopovers, setInvoicePopovers] = useState(
        new Array(ocrBankDetails.length).fill(false)
    );
    const [invoiceBankValidationIcons, setInvoiceBankValidationIcons] = useState(
        Array(bankDetails.length).fill("DownCircleOutlined")
    );
    const [recoveryTypeOptions, setRecoveryTypeOptions] = useState([]);
    pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJSWorker;
    const zoomPluginInstance = zoomPlugin();
    const {Zoom} = zoomPluginInstance;
    const {CurrentScale, ZoomIn, ZoomOut} = zoomPluginInstance;
    const pageNavigationPluginInstance = pageNavigationPlugin();
    const {
        CurrentPageLabel,
        GoToFirstPage,
        GoToLastPage,
        GoToNextPage,
        GoToPreviousPage,
    } = pageNavigationPluginInstance;
    const thumbnailPluginInstance = thumbnailPlugin();
    const {Thumbnails} = thumbnailPluginInstance;
    const navigate = useNavigate();
    const {userData, userManager} = useAuth();
    const token = userData?.access_token;
    // Mutable refs (replaced module-level vars)
    const validatedDataRef = useRef([]);
    const pcnDataArrayRef = useRef([]);
    const countRef = useRef(0);
    const descriptionwithTaxRef = useRef([]);
    const hasDescriptionWithTaxRef = useRef(false);
    const hasTaxValueCheckRef = useRef("");
    const isDraftClickedRef = useRef(false);
    const updatedDataRef = useRef([]);
    const isFirstRenderRef = useRef(true);
    // Tracks whether the form is in read-only mode for the edit guard below.
    const isFormReadOnlyRef = useRef(false);
    const getSplitData = [];

    // When the form is read-only we still want users to be able to select and
    // copy field values, so the inputs stay interactive (see .form-readonly CSS).
    // This capture-phase guard blocks any actual edit (typing, paste, cut, drop)
    // on inputs/textareas without affecting selection or copy.
    const attachReadOnlyGuard = useCallback((node) => {
        if (!node) return;
        node.addEventListener(
            "beforeinput",
            (e) => {
                if (!isFormReadOnlyRef.current) return;
                const tag = e.target?.tagName;
                if (tag === "INPUT" || tag === "TEXTAREA") e.preventDefault();
            },
            true
        );
    }, []);
    const [fileList, setFileList] = useState([]);
    const [uploadedAttachments, setUploadedAttachments] = useState([]);
    const [deleteAttachmentsList, setDeleteAttachmentsList] = useState([]);
    const [updatedDataCount, setUpdatedDataCount] = useState(0);

    const actionItems = [
        {
            key: 'reject',
            icon: <CloseOutlined/>,
            label: 'Reject',
            disabled: !user || selectedItem?.processingStatus === ProcessingStatusEnum.Rejected,
            action: () => setIsPopupVisible(true)
        },
        {
            key: 'delete',
            icon: <DeleteOutlined/>,
            label: 'Delete',
            disabled: !user,
            danger: true,
            action: () => setIsPopupDeleteVisible(true)
        },
        {
            key: 'onhold',
            icon: <WarningOutlined/>,
            label: 'Mark as On Hold',
            disabled: !user || selectedItem?.processingStatus === ProcessingStatusEnum.OnHold,
            className: 'menu-item-warning',
            action: () => setIsUpdateInvoiceOnHoldModalVisible(true)
        },
        {
            key: 'complete',
            icon: <CheckCircleOutlined/>,
            label: 'Mark as Complete',
            disabled: !(user?.isAdmin || user?.isManager) || selectedItem?.processingStatus === ProcessingStatusEnum.InvoiceCreated,
            action: () => setIsUpdateInvoiceModalVisible(true)
        },
        ...(convertToBoolean(REACT_APP_SETTINGS_SHOW_REPROCESS_BUTTON) ? [{
            key: 'reprocess',
            icon: <ReloadOutlined/>,
            label: 'Reprocess',
            disabled: !(user || selectedItem?.processingStatus === ProcessingStatusEnum.InvoiceCreated),
            action: () => setIsReprocessInvoiceModalVisible(true)
        }] : [])
    ];

    useEffect(() => {
        if (token) {
            const decodedToken = jwtDecode(token);

            SharedService.get({token: token, url: "user"})
                .then(response => {
                    if (response) {
                        const next = {...response, token, userName: decodedToken?.name};
                        userRef.current = next;
                        setUser(next);
                    }
                });
        }
    }, [token]);

    useEffect(() => {
        setDisableSave(updatedDataRef.current.length === 0 && fileList.length === 0 && deleteAttachmentsList.length === 0);
        setDisableSubmit(updatedDataRef.current.length > 0 || fileList.length > 0 || deleteAttachmentsList.length > 0);
    }, [fileList.length, deleteAttachmentsList.length, updatedDataCount]);

    useEffect(() => {
        setIsOpenArray(Array(ocrBankDetails.length).fill(false));
    }, [ocrBankDetails]);

    useEffect(() => {
        let index =
            bankDetails &&
            bankDetails.length > 0 &&
            bankDetails.findIndex(
                (item) => item?.bankValidation?.bankValidationStatus === "Validated"
            );
        setShipSureIndex(index);
    }, [bankDetails]);

    useEffect(() => {
        const storedRadioValue = localStorage.getItem("radioValue");
        if (storedRadioValue) {
            setSelectedRadioOption(storedRadioValue);
        } else {
            setSelectedRadioOption("toBeProcessed");
        }
        updatedDataRef.current = [];
        setUpdatedDataCount(0);
        currencyGetData();
        getDocumentType();
        getDepartments();
        getFNTaxCodeIds();
        fetchEntityType();
        recoveryServiceTypes();
        taxReferenceTypes();
    }, []);

    const refreshAccessToken = async () => {
        try {
            await userManager.signinSilent();
        } catch (error) {
        }
    };

    useEffect(() => {
        const refreshInterval = setInterval(() => {
            refreshAccessToken();
        }, 600000); // Refresh token every 5 minutes (adjust as needed)

        return () => clearInterval(refreshInterval); // Cleanup on component unmount
    }, [userManager]);

    useEffect(() => {
        if (findData("BankAccountStatus")) {
            let value = findData("BankAccountStatus");
            setSelectedValue(value);
        } else {
            setSelectedValue("NotValidated");
        }
    }, [invoiceDetailData]);

    useEffect(() => {
        fetchOutcome();
    }, [id]);

    const closeSelect = () => {
        setIsSelectOpen(false);
    };

    useEffect(() => {
        if (!recoveryData || recoveryData.length === 0) {
            handleAddRecovery();
        }
    }, [recoveryData]);

    useEffect(() => {
        document.addEventListener("click", closeSelect);

        return () => {
            document.removeEventListener("click", closeSelect);
        };
    }, []);

    useEffect(() => {
        const base64String1 = pdfData;

        const base64String = base64String1;
        if (base64String) {
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: "application/pdf"});
            const generatedUrl = URL.createObjectURL(blob);
            setUrl(generatedUrl);
            return () => {
                URL.revokeObjectURL(generatedUrl);
            };
        }

        setPdfData(base64String);

        setUrlGenerated(true);
    }, [pdfData]);

    useEffect(() => {
        // Check if the "round values" checkbox is checked
        if (roundValues === true && roundValues !== undefined) {
            // Iterate through the keys that need rounding
            ["InvoiceTotal"].forEach((key) => {
                // Get the current value for the key
                const currentValue = findData(key);
                const numericValue = parseFloat(currentValue);

                // Check if the value is a valid number
                if (
                    !isNaN(numericValue) &&
                    numericValue !== "" &&
                    numericValue !== null
                ) {
                    // Round to 2 decimal places

                    const roundedValue = Math.round(numericValue).toFixed(2);

                    // Log statements for debugging

                    // Update the state with the rounded value
                    if (roundedValue && currentValue && currentValue !== roundedValue) {
                        updateDetailData(key, roundedValue);
                    }
                }
            });
        }
    }, [roundValues]);

    useEffect(() => {
        // Check if invoiceDetailData and selectedItem exist and have data
        if (
            invoiceDetailData &&
            invoiceDetailData.length > 0 &&
            selectedItem &&
            (!supplierOptions || supplierOptions.length === 0)
        ) {
            // Initialize supplierIdValue to an empty string
            let supplierIdValue = "";

            // Check if a "CompanySupplierId" is available in the data
            if (findData("SupplierId")) {
                supplierIdValue = findData("SupplierId");
            }

            // If supplierIdValue is still empty and there's a senderEmail in selectedItem,
            // fetch the supplier options
            if (!supplierIdValue && selectedItem?.emailValidationQueue?.senderEmail) {
                fetchSupplierOptions(true);
            }
        }
    }, [invoiceDetailData, selectedItem]);

    useEffect(() => {
        fetchSupplierOptions();
    }, [supplierSearchText]);

    useEffect(() => {
        const newCrewRecoveryType = recoveryData.map((item) => {
            return getDescriptionItem(item, "RecoveryServiceType");
        });

        setCrewRecoveryTypeDropdown(newCrewRecoveryType);
    }, [recoveryData]);


    useEffect(() => {
        const processedKeys = new Set();
        const coyDataId = findData("CoyId");
        setCoyIdPO(coyDataId);
        const sum = invoiceDetailData.reduce((accumulator, item) => {
            if (
                ["SubTotal", "TotalDiscount", "TotalTax", "Freight", "Packaging"].includes(item.key) &&
                !processedKeys.has(item.key)
            ) {
                processedKeys.add(item.key); // Mark key as processed
                const rawValue = getKeyValue(item);
                const sanitizedValue = parseFloat(
                    removeAlphabetsFromString(rawValue)
                ); // Convert sanitized string to number

                if (!isNaN(sanitizedValue)) {

                    return accumulator + ((item.key === "TotalDiscount" && sanitizedValue > 0) ? -Math.abs(sanitizedValue) : sanitizedValue);
                }
            }
            return accumulator;
        }, 0);
        setTotal(sum);
        processedKeys.clear();

    }, [invoiceDetailData]);

    useEffect(() => {

        if (
            findData("PurchaseOrderNumber") &&
            findData("PurchaseOrder") &&
            poFlag &&
            (convertToBoolean(findData("PurchaseOrderValidated")) || findData("PurchaseOrderValidated") === null)
        ) {
            fetchPurchaseOrder();
        }
    }, [invoiceDetailData]);


    useEffect(() => {
        if (findData("SupplierId")) {
            fetchSupplierBySupplierId(findData("SupplierId"));
        }
    }, []);

    useEffect(() => {

        const crewRecoveryKey = findData("IsCrewRecovery");

        if (crewRecoveryKey === null && supplierDetails && typeof supplierDetails === "object") {
            setIsCrewRecovery(supplierDetails?.isRecoverySupplier);
        } else {
            setIsCrewRecovery(convertToBoolean(crewRecoveryKey));
        }

    }, [invoiceDetailData, isCrewRecovery, supplierDetails]);

    useEffect(() => {
        const isMastersAndOwners = findData("IsMasterAndOwners");
        const isMultiCompanyInvoice = findData("IsMultiCompany");
        const isCrewRecovery = findData("IsCrewRecovery");
        const custType = findData("CustomerType");
        const coyId = findData("CoyId");

        if (coyId) {
            fetchCustomerById(coyId).then((customer) => {
                const country = customer?.company?.country;
                setCustomerCountryCode(country?.isoA3 ?? country ?? "");
            });
        } else {
            setCustomerCountryCode("");
        }

        setIsMasterAndOwners(isMastersAndOwners !== null ? isMastersAndOwners : false);
        setIsMultiCompany(isMultiCompanyInvoice !== null ? convertToBoolean(isMultiCompanyInvoice) : false);

        //Disable if Type Entity
        if (custType != null) {
            setCustomerType(custType);
            setIsMasterAndOwnersDisabled(custType === "entity")
        }
    }, [invoiceDetailData]);

    useEffect(() => {
        invoicePdfData();
        fetchData().then((result) => {
            setPdfData(result);
        });
    }, [id]);

    useEffect(() => {
        const coyId = findData("CoyId");
        if (coyId && coyId !== lastCheckedCoyIdRef.current) {
            lastCheckedCoyIdRef.current = coyId;
            checkVesselManagementStatus({customerId: coyId});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoiceDetailData]);

    useEffect(() => {
        descriptionwithTaxRef.current = [];
        if (invoiceGetData && invoiceGetData.length > 0) {
            invoiceGetData.forEach((item) => {
                const desc = getDescriptionItem(item, "Description");
                if (["Taxes", "taxes", "Tax", "tax"].includes(desc)) {
                    hasTaxValueCheckRef.current = removeAlphabetsFromString(
                        getDescriptionItem(item, "Amount")
                    );
                }
                descriptionwithTaxRef.current.push(desc);
            });
        }
        hasDescriptionWithTaxRef.current = descriptionwithTaxRef.current.find(
            (item) => ["Taxes", "taxes", "Tax", "tax"].includes(item)
        );
    }, [invoiceGetData]);

    useEffect(() => {
        let detailSum = 0;
        const jsonData = invoiceGetData;

        if (isConsolidatedDetailLines) {
            const subTotal = findData("SubTotal");
            setAmountSum(subTotal);
        } else {
            if (jsonData) {
                jsonData.forEach((item) => {
                    if (item.Amount) {
                        const amount = parseFloat(
                            removeAlphabetsFromString(
                                getKeyValue(item.Amount)
                            )
                        );

                        detailSum += amount;
                    }
                });
                const roundedSum = Math.round(detailSum * 100) / 100;
                setAmountSum(roundedSum);
            }
        }

    }, [invoiceGetData, isConsolidatedDetailLines]);

    const handleInvoiceDetail = (data) => {
        data.forEach((item, index) => {
            const {
                lineIndex,
                value,
                key,
                confidencePercent,
                id,
                type,
                correctedValue,
                confidenceValueSuccess,
                confidenceValidated,
            } = item;
            if (lineIndex !== null) {
                if (!getSplitData[lineIndex]) {
                    getSplitData[lineIndex] = [];
                }
                getSplitData[lineIndex] = {
                    ...getSplitData[lineIndex],
                    [key]: {
                        value,
                        confidencePercent,
                        id,
                        lineIndex,
                        type,
                        key,
                        correctedValue,
                        confidenceValueSuccess,
                        confidenceValidated,
                        className: correctedValue
                            ? "border-yellow-500	"
                            : "border-[#CDD6DB]",
                    },
                };
            }
        });

        const filteredInvoiceData = getSplitData
            .filter((data) => data !== undefined)
            .map((item) => ({
                Amount: item.Amount,
                Description: item.Description,
                Quantity: item.Quantity,
                UnitPrice: item.UnitPrice,
            }))
            .filter(
                (item) =>
                    (item.Amount !== undefined && item.Amount) ||
                    (item.Description !== undefined && item.Description) ||
                    (item.Quantity !== undefined && item.Quantity) ||
                    (item.UnitPrice !== undefined && item.UnitPrice)
            );

        setInvoiceGetData(filteredInvoiceData);

        if (getSplitData && getSplitData.length > 0) {
            const filteredData = getSplitData
                .filter((data) => data !== undefined)
                .map((item) => ({
                    IBAN: item.IBAN,
                    IFSC: item.IFSC,
                    SWIFT: item.SWIFT,
                    BankCurrencyCode: item.BankCurrencyCode,
                    Accountnumber: item.Accountnumber,
                    BankName: item.BankName,
                    BankAccountStatus: item.BankAccountStatus,
                    InvoiceBankValidationStatus: item.InvoiceBankValidationStatus,
                }))
                .filter(
                    (item) =>
                        (item.IBAN !== undefined && item.IBAN) ||
                        (item.IFSC !== undefined && item.IFSC) ||
                        (item.BankAccountStatus !== undefined && item.BankAccountStatus) ||
                        (item.SWIFT !== undefined && item.SWIFT) ||
                        (item.BankCurrencyCode !== undefined && item.BankCurrencyCode) ||
                        (item.Accountnumber !== undefined && item.Accountnumber) ||
                        (item.BankName !== undefined && item.BankName) ||
                        (item.InvoiceBankValidationStatus !== undefined &&
                            item.InvoiceBankValidationStatus)
                );

            setOcrBankDetails(filteredData);

            const filteredRecoveryData = getSplitData
                .filter((data) => data !== undefined)
                .map((item) => ({
                    RecoveryPCN: item.RecoveryPCN,
                    RecoveryVesselName: item.RecoveryVesselName,
                    RecoverySeafarerName: item.RecoverySeafarerName,
                    RecoveryServiceType: item.RecoveryServiceType,
                    RecoveryVesselId: item.RecoveryVesselId,
                    RecoveryType: item.RecoveryType,
                    RecoveryAmount: item.RecoveryAmount,
                    RecoveryOneTime: item.RecoveryOneTime,
                    RecoveryFI: item.RecoveryFI,
                }))
                .filter(
                    (item) =>
                        (item.RecoveryPCN !== undefined && item.RecoveryPCN) ||
                        (item.RecoveryVesselName !== undefined && item.RecoveryVesselName) ||
                        (item.RecoverySeafarerName !== undefined && item.RecoverySeafarerName) ||
                        (item.RecoveryServiceType !== undefined && item.RecoveryServiceType) ||
                        (item.RecoveryVesselId !== undefined && item.RecoveryVesselId) ||
                        (item.RecoveryType !== undefined && item.RecoveryType) ||
                        (item.RecoveryAmount !== undefined && item.RecoveryAmount) ||
                        (item.RecoveryOneTime !== undefined && item.RecoveryOneTime) ||
                        (item.RecoveryFI !== undefined && item.RecoveryFI)
                );

            setRecoveryData(filteredRecoveryData);

            const filteredTaxItems = getSplitData
                .filter((data) => data !== undefined)
                .map((item) => ({
                    Tax: item.Tax,
                    TaxRate: item.TaxRate,
                    TaxType: item.TaxType,

                }))
                .filter(
                    (item) =>
                        (item.Tax !== undefined && item.Tax) ||
                        (item.TaxRate !== undefined &&
                            item.TaxRate) ||
                        (item.TaxType !== undefined &&
                            item.TaxType)
                );


            setTaxItems(filteredTaxItems)
            // getRecoveryTypeandData(recoveryType, filteredRecoveryData);

            const filteredRecoveryPcn = getSplitData
                .filter((data) => data !== undefined)
                .map((item) => ({
                    RecoveryPCN: item.RecoveryPCN,
                }))
                .filter((item) => item.RecoveryPCN !== undefined && item.RecoveryPCN);

            filteredRecoveryPcn.map((item) => {
                let recoveryPcn =
                    getKeyValue(item.RecoveryPCN);
                fetchRecoveryCrewValidation(recoveryPcn);
            });

            setRecoveryPcn(filteredRecoveryPcn);
        }
    };

    const handleDeleteBankingItem = (e, index) => {
        let data = ocrBankDetails[index];
        const deletedIds = Object.values(data)
            .filter((item) => item !== undefined)
            .map((item) => {
                return {id: item.id, updatedBy: user?.email};
            });
        const newData = [...ocrBankDetails];
        newData.splice(index, 1);
        setOcrBankDetails(newData);
        deleteInvoiceDetailData(deletedIds);
    };

    const handleDeleteRecoveryItem = async (e, index) => {

        let data = recoveryData[index];

        /*
         * [RG] GET ID'S TO DELETE
         */
        const deletedIds = Object.values(data)
            .filter((item) => item !== undefined && item?.id !== undefined && (item?.id !== null || item?.id !== 0))
            .map((item) => ({
                id: item?.id,
                updatedBy: user?.email
            }))

        /*
         * [RG] GET ITEMS IN UPDATE DATA
         */
        const itemsWithNoIds = Object.values(data)
            .filter((item) => item !== undefined && !item?.id) // `!item?.id` covers undefined, null, and 0
            .map(({key, lineIndex}) => ({key, lineIndex}));

        if (itemsWithNoIds.length > 0) {
            updatedDataRef.current = updatedDataRef.current.filter(
                (updatedItem) =>
                    !itemsWithNoIds.some(
                        (item) =>
                            updatedItem.key === item.key && updatedItem.lineIndex === item.lineIndex
                    )
            );
            setUpdatedDataCount(updatedDataRef.current.length);
        }

        const newData = [...recoveryData];
        newData.splice(index, 1);

        /*
         * [RG] UPDATE THE INDEX OF THE EXISTING ITEMS TO BE SEQUENTIAL
         */
        const updatedRecoveryData = newData.map((item, index) => {
            if (!item) return item; // Skip undefined items

            return Object.entries(item).reduce((acc, [key, value]) => {
                if (value) {
                    acc[key] = {
                        ...value,
                        lineIndex: index, // Use the current index as lineIndex
                        updatedBy: user?.email,
                        value: value.correctedValue ?? value.value,
                        correctedValue: value.correctedValue,
                    };
                } else {
                    acc[key] = value; // Preserve undefined/null entries
                }

                if (acc[key] && acc[key].id > 0) {
                    updatedDataRef.current.push(acc[key]);
                    setUpdatedDataCount(updatedDataRef.current.length);
                }

                return acc;
            }, {});
        });

        setRecoveryData(updatedRecoveryData);

        /*
         * [RG] DELETE REMOVED RECOVERIES
         */
        if (deletedIds.length > 0) {
            deleteInvoiceDetailData(deletedIds);
        }

        /*
         * [RG] SAVE INVOICE
         */
        if (updatedRecoveryData.length > 0) {
            await handleDraftClick();
        }
    };

    const fetchOutcome = async () => {
        try {
            const data = await SharedService.get({
                token,
                url: `document/${id}`,
            });
            setSelectedItem(data);

            const responseData = data?.validationOutcome?.processOutcome;

            let supplierId = data?.supplierId;
            if (supplierId === null) {
                setSupplierDetails([]);
            }
            fetchEmailById(supplierId, id);
            fetchSupplierBySupplierId(supplierId);
            fetchShipsureBankDetails(supplierId);

            const supplierdata = JSON.parse(responseData);
            setSupplierOutcome(supplierdata[0].Value);
        } catch (error) {
        }
    };

    const currencyGetData = async () => {
        try {
            const jsonData = await SharedService.get({
                token,
                url: "reference/accounting/currency",
            });
            if (jsonData) {

                const filteredCurrencies = jsonData.filter(
                    (currency) =>
                        !companyAllowedCurrencies.find(
                            (allowedCurrency) => allowedCurrency.value === currency.id
                        )
                );

                setCurrencyOptions(filteredCurrencies);
            }
        } catch (error) {
            notification.error({
                message: "Error",
                description: error?.response?.statusText,
            });
        }
    };

    const getDepartments = async () => {
        try {
            const response = await SharedService.get({
                token,
                url: "reference/departments",
            });
            setDepartmentOptions(
                (response ?? []).map((option) => ({
                    label: option.value ?? option.name ?? option.id,
                    value: String(option.id),
                }))
            );
        } catch (error) {
            console.error("Failed to load departments", error);
        }
    };

    const getFNTaxCodeIds = async () => {
        try {
            const response = await SharedService.get({
                token,
                url: "reference/finance/taxcode/types",
            });
            setFNTaxCodeIdTypes(response ?? []);
        } catch (error) {
            console.error("Failed to load finance tax codes", error);
        }
    };

    const getDocumentType = async () => {
        try {
            const response = await SharedService.get({
                token,
                url: "reference/document/classificationtypes",
            });

            setDocumentTypeOptions(
                (response ?? [])
                    .filter((item) => item.value !== "Error")
                    .map((option) => ({
                        label: `${option.value}`,
                        value: `${option.id}`,
                    }))
            );
        } catch (error) {
            notification.error({
                message: "Error",
                description: error?.response?.statusText,
            });
        }
    };

    const invoicePdfData = async () => {
        pcnDataArrayRef.current = [];

        try {
            let responseData = await SharedService.get({
                token,
                url: `kvps/${id}`,
            }) ?? [];
            pcnDataArrayRef.current = [];

            handleInvoiceDetail(responseData);

            if (
                !responseData.find((item) => item.key === "PurchaseOrder")?.value ||
                !responseData.find((item) => item.key === "VesselName")?.value ||
                !responseData.find((item) => item.key === "SupplierName")?.value ||
                !responseData.find((item) => item.key === "CustomerName") ||
                !responseData.find((item) => item.key === "CustomerName")?.value
            ) {
                setInvoiceDetailData(responseData);
            } else {

                if (!responseData.find((item) => item.key === "PurchaseOrder")?.value) {
                    responseData = [
                        ...responseData,
                        {
                            id: 0,
                            type: typeObject.PurchaseOrder,
                            key: "PurchaseOrder",
                            lineIndex: null,
                            value: "",
                            confidencePercent: null,
                            correctedValue: "",
                            updatedOn: user?.email,
                        },
                    ];
                }

                if (!responseData.find((item) => item.key === "VesselName")?.value) {
                    responseData = [
                        ...responseData,
                        {
                            id: 0,
                            type: typeObject.VesselName,
                            key: "VesselName",
                            lineIndex: null,
                            value: "",
                            confidencePercent: null,
                            correctedValue: "",
                            updatedOn: user?.email,
                        },
                    ];
                }

                if (!responseData.find((item) => item.key === "SupplierName")?.value) {
                    const supplierId = responseData.find(
                        (item) => item.key === "SupplierId"
                    )?.value;

                    let supplierData = await fetchSupplierById(supplierId);
                    responseData = [
                        ...responseData,
                        {
                            id: 0,
                            type: typeObject.SupplierName,
                            key: "SupplierName",
                            lineIndex: null,
                            value: "",
                            confidencePercent: supplierData ? 100 : null,
                            correctedValue: supplierData?.name,
                            updatedOn: user?.email,
                        },
                    ];
                }

                if (!responseData.find((item) => item.key === "CustomerName")) {
                    const customerID = responseData.find(
                        (item) => item.key === "CoyId"
                    ).value;

                    let customerNameData = await fetchCustomerById(customerID);
                    responseData = [
                        ...responseData,
                        {
                            id: 0,
                            type: typeObject.CustomerName,
                            key: "CustomerName",
                            lineIndex: null,
                            value: "",
                            confidencePercent: 100,
                            correctedValue: customerNameData.name,
                            updatedOn: user?.email,
                        },
                    ];
                }

                if (!responseData.find((item) => item.key === "CustomerName")?.value) {
                    const companyCustomerID = responseData.find(
                        (item) => item.key === "CoyId"
                    )?.value;

                    let companyCustomerNameData = await fetchCustomerById(
                        companyCustomerID
                    );

                    const index = responseData.findIndex((item) => item.key === "CoyId");

                    if (index > -1) {
                        let data = responseData[index];
                        data.correctedValue = companyCustomerNameData?.id;
                        responseData[index] = data;
                    } else {
                        responseData = [
                            ...responseData,
                            {
                                id: 0,
                                type: typeObject.CoyId,
                                key: "CoyId",
                                lineIndex: null,
                                value: "",
                                confidencePercent: companyCustomerNameData ? 100 : null,
                                correctedValue: companyCustomerNameData?.id,
                                updatedOn: user?.email,
                            },
                        ];
                    }

                    responseData = [
                        ...responseData,
                        {
                            id: 0,
                            type: typeObject.CustomerName,
                            key: "CustomerName",
                            lineIndex: null,
                            value: "",
                            confidencePercent: 100,
                            correctedValue: companyCustomerNameData?.name,
                            updatedOn: user?.email,
                        },
                    ];
                }

                setInvoiceDetailData(responseData);
            }
        } catch (error) {
            console.error("InvoiceDetail Error:", error);
            if (error?.request?.status === 404) {
                notification.error({
                    message: "Error",
                    description: error.response.data.message,
                });
            } else {
                notification.error({
                    message: "Error",
                    description: error?.response?.statusText,
                });
            }
        }
    };

    const getBodyParams = () => {
        const purchaseOrder = invoiceDetailData.find((item) => {
            return item.key === "PurchaseOrderNumber";
        });
        const purchaseData = getKeyValue(purchaseOrder);

        const coyIdData = invoiceDetailData.find((item) => {
            return item.key === "CoyId";
        });
        const coyIdValue = coyIdData?.correctedValue ?? coyIdData?.value;
        let data = {};

        if (purchaseData) {
            const purchaseSplit = purchaseData.split("-");
            const splittedPurchaseNumber =
                purchaseSplit.length > 1 ? purchaseSplit[1] : purchaseData;
            data.purchaseOrderNumber = splittedPurchaseNumber;
            data.accountingCoyId = coyIdValue;
        }

        return data;
    };

    const fetchPurchaseOrder = async () => {
        setloading(true);
        try {
            const response = await SharedService.post({
                token,
                url: "purchaseorder/search",
                data: getBodyParams(),
            });
            setPoFlag(false);
            let jsonData = response?.items;

            const isValid = jsonData.some(
                item =>
                    item?.supplier?.id === findData("SupplierId") &&
                    item?.accountingCoyId === findData("CoyId")
            );
            setPoValidation(isValid);
            updateDetailData("PurchaseOrderValidated", isValid);

            setloading(false);
        } catch (error) {
            setloading(false);
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
        }
    };

    const fetchSupplierOptions = (isGet) => {
        setSupplierOptions([]);

        let promise;
        if (isGet) {
            const senderEmail = selectedItem?.emailValidationQueue?.senderEmail;
            setIsSelectOpen(true);
            promise = SharedService.get({
                token,
                url: `supplier/email/${senderEmail}`,
            });
        } else if (supplierSearchText && supplierSearchText.length > 2) {
            setIsSelectOpen(true);
            promise = SharedService.post({
                token,
                url: "supplier/search/autocomplete",
                data: {searchTerm: supplierSearchText},
            });
        } else {
            return;
        }

        setSupplierLoading(true);
        promise
            .then((response) => {
                setSupplierOptions(response);
                setSupplierLoading(false);
            })
            .catch((error) => {
                setSupplierLoading(false);
                setIsSelectOpen(false);
                if (error.response && error.response.status === 404) {
                    notification.error({
                        message: "Error",
                        description: "Resource not found (404 error)",
                    });
                }
                if (error.response && error.response.status === 500) {
                    notification.error({
                        message: "Error",
                        description: error.response?.statusText,
                    });
                }
            });
    };

    const fetchEmailById = async (supplierid, documentid) => {
        try {
            const response = await SharedService.get({
                token,
                url: `supplier/${supplierid}/emails/${documentid}`,
            });
            if (response) {
                let emails = response.map((item) => ({
                    label: `${item.email} (${item.type})`,
                    value: `${item.id}`,
                }));
                setEmailData(emails);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchSupplierBySupplierId = async (id) => {
        try {
            const data = await SharedService.get({
                token,
                url: `supplier/${id}`,
            });

            if (data) {
                setSupplierDetails(data);

                data.Address =
                    data?.address?.address +
                    " " +
                    data?.address?.town +
                    " " +
                    data?.address?.state +
                    " " +
                    data?.address?.postCode +
                    " " +
                    "," +
                    data?.address?.country;


                const sortedOptions = data?.recoveryServiceTypes
                    ?.map((option) => ({
                        label: `${option.value}`,
                        value: option.id,
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));
                setCompanyAllowedCurrencies(data.companyAllowedCurrencies);
                setRecoveryType(sortedOptions);
                if (
                    data?.permitInvoiceRounding !== null &&
                    data?.permitInvoiceRounding !== undefined
                ) {
                    setRoundValues(data?.permitInvoiceRounding);
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
        }
    };

    const fetchRecoveryVesselOptions = async (searchText) => {
        setVesselLoading(true);
        try {
            const response = await SharedService.post({
                token,
                url: "customer/search/autocomplete",
                data: {
                    searchTerm: searchText,
                    entityType: "vessel",
                },
            });
            setVesselLoading(false);

            let options = (response ?? []).map((item) => ({
                label: item.displayName,
                value: item.name,
                vesselId: item.vesselId,
            }));
            setRecoveryVessel(options);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
        }
    };

    const fetchShipsureBankDetails = async (supplierid) => {

        if (supplierid === null) {
            setSupplierDetails([]);
            return
        }

        try {
            const response = await SharedService.post({
                token,
                url: "supplier/bank/details",
                data: {
                    supplierId: supplierid,
                    documentId: id,
                },
            });

            if (response) {
                setBankDetails(response);
                if (
                    response?.permitInvoiceRounding !== null &&
                    response?.permitInvoiceRounding !== undefined
                ) {
                    setRoundValues(response?.permitInvoiceRounding);
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            } else if (error.response && error.response.status === 400) {
                setSupplierDetails([]);
            }
        }
    };

    const fetchRecoveryCrewValidation = async (pcnId) => {
        try {
            const response = await SharedService.post({
                token,
                url: "recovery/crew/search",
                data: {pcn: pcnId},
            });
            setShipsureCrewData(response?.items);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
        }
    };

    const fetchCustomerOptions = async (searchText) => {
        setCustomerOptions([]);
        setCustomerLoading(true);
        try {
            const response = await SharedService.post({
                token,
                url: "customer/search/autocomplete",
                data: {searchTerm: searchText},
            });
            if (customerAutocomplete === "vessel") {
                setVesselName(response);
            }

            let options = (response ?? []).map((item) => ({
                label: `${item.displayName}${item?.vesselName ? ` - (${item.vesselName})` : ``}`,
                value: `${item.displayName}${item?.vesselName ? ` - (${item.vesselName})` : ``}`,
                VesselId: item.vesselId,
                id: item.id,
                VesselName: item?.vesselName,
                customerName: item.name,
                CoyId: item.id,
                AccountingType: item.accountingType,
                consolidateDetailLines: item.consolidateDetailLines,
                vesselManagementEndDate: item.vesselManagementEndDate ?? null,
                vesselResponsibilities: item.vesselResponsibilities ?? null,
            }));

            setCustomerOptions(options);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
        } finally {
            setCustomerLoading(false);
        }
    };

    const fetchData = async () => {
        pcnDataArrayRef.current = [];
        try {
            const response = await SharedService.get({
                token,
                url: `document/${id}/attachment`,
            });
            const jsonData = response?.base64File;

            if (jsonData) {
                setPdfData(jsonData);
                setFile(response);
            }

            return jsonData;
        } catch (error) {
            console.error("InvoiceDetail fetchData Error:", error);
            return null;
        }
    };

    const fetchEntityType = async () => {
        try {
            const response = await SharedService.get({
                token,
                url: "reference/accounting/entitytype",
            });

            setEntityType(
                (response ?? [])
                    .filter((option) => option.value !== "Unknown")
                    .map((option) => ({
                        label: option.id,
                        value: option.value,
                    }))
            );
        } catch (error) {
            notification.error({
                message: "Error",
                description: error.response?.statusText,
            });
        }
    };

    const recoveryServiceTypes = async () => {
        try {
            const response = await SharedService.get({
                token,
                url: "reference/recovery/servicetypes",
            });
            const sortedOptions = (response ?? [])
                .map((option) => ({
                    label: `${option.value}`,
                    value: option.id,
                }))
                .sort((a, b) => a.label.localeCompare(b.label));

            setRecoveryTypeOptions(sortedOptions);
        } catch (error) {
            notification.error({
                message: "Error",
                description: error.response?.statusText,
            });
        }
    };

    const taxReferenceTypes = async () => {
        try {
            const response = await SharedService.get({
                token,
                url: "reference/tax/types",
            });
            const sortedOptions = (response ?? [])
                .map((option) => ({
                    label: `${option.value}`,
                    value: option.id,
                }))
                .sort((a, b) => a.label.localeCompare(b.label));
            setTaxTypeOptions(sortedOptions);
        } catch (error) {
            notification.error({
                message: "Error",
                description: error.response?.statusText,
            });
        }
    };

    const fetchCustomerById = async (customerId) => {
        try {
            const jsonData = await SharedService.get({
                token,
                url: `customer/${customerId}`,
            });

            if (jsonData && jsonData?.consolidateDetailLines !== null) {
                setIsConsolidatedDetailLines(jsonData.consolidateDetailLines ?? false);
            }

            return jsonData;
        } catch (error) {
            return null;
        }
    };

    const fetchSupplierById = async (supplierId) => {
        try {
            return await SharedService.get({
                token,
                url: `supplier/${supplierId}`,
            });
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
            return null;
        }
    };

    const handlePopupDeleteClose = () => {
        setIsPopupDeleteVisible(false);
    };

    const handlePopupClose = () => {
        setIsPopupVisible(false);
    };

    const handleSupplierPopupClose = () => {
        setIsSupplierPopup(false);
    };

    const handleImageClick = () => {
        setPopupVisible(true);
    };

    const handleCrewRecoveryPopupClosed = () => {
        setCrewRecoveryPopup(false);
    };

    const handlePopupClosed = () => {
        setPopupVisible(false);
    };

    const handleRecoveryPopup = (index) => {
        setRecoveryIndexPopup(index);

        setCrewRecoveryPopup(true);
    };
    const handleAddButtonClick = (purchaseData) => {
        updateDetailData("SupplierId", purchaseData?.supplier?.id);
        updateDetailData("SupplierName", purchaseData?.supplier?.name);
        updateDetailData("PurchaseOrder", purchaseData?.number);
        updateDetailData("PurchaseOrderNumber", purchaseData?.number);
        updateDetailData("VesselName", purchaseData?.vessel?.name);
        updateDetailData("VesselId", purchaseData?.vessel?.id);
        updateDetailData("CoyId", purchaseData?.accountingCoyId);
        updateDetailData("CustomerName", purchaseData?.accountingCoyName);

        fetchSupplierBySupplierId(purchaseData?.supplier?.id)

        fetchPurchaseOrder();

        setPopupVisible(false);

        // Add logic for handling the add button click here
    };
    const handleAddRecoveryFromPopup = (crewData, index) => {
        if (crewData[0]?.vesselName !== null) {
            handleInputRecoveryChange(
                "RecoveryVesselName",
                crewData[0].vesselName,
                recoveryIndexPopup
            );
        } else {
            handleInputRecoveryChange("RecoveryVesselName", "", recoveryIndexPopup);
        }

        if (crewData[0]?.vesselId !== null) {
            handleInputRecoveryChange(
                "RecoveryVesselId",
                crewData[0].vesselId,
                recoveryIndexPopup
            );
        } else {
            handleInputRecoveryChange("RecoveryVesselId", "", recoveryIndexPopup);
        }

        handleInputRecoveryChange(
            "RecoveryPCN",
            crewData[0].pcn,
            recoveryIndexPopup
        );

        handleInputRecoveryChange(
            "RecoverySeafarerName",
            crewData[0].forename + " " + crewData[0].surname,
            recoveryIndexPopup
        );

        setCrewRecoveryPopup(false);
    };
    const deleteInvoiceDetailData = (deletedIds) => {
        pcnDataArrayRef.current = [];

        SharedService.delete({
            token,
            url: `kvp/${id}`,
            data: deletedIds,
        })
            .then(() => {
                notification.success({
                    message: "Deleted Successfully",
                });
            })
            .catch((error) => {
                console.error("InvoiceDetail delete kvp Error:", error);
            });
    };

    const borderColor = (id) => {
        return invoiceDetailData.find((item) => item.key === id)?.correctedValue
            ? "border-yellow-500"
            : "border";
    };

    const findData = (id) => {
        return (
            getKeyValue(invoiceDetailData.find((item) => item.key === id))
        );
    };

    const findIndexData = (id, index) => {
        return (
            getKeyValue(invoiceDetailData.find((item) => item.key === id && item.lineIndex === index))
        );
    };

    const findSupplierData = (id) => {
        return invoiceDetailData.find((item) => item.key === id)?.correctedValue;
    };
    const filterOption = (input, option) => {
        return (
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
            option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
    };

    const findLargestLineIndex = (data) => {
        let largestIndex = -1;

        data.forEach(obj => {
            const amountLineIndex = obj?.Amount?.lineIndex ?? 0;
            const descriptionLineIndex = obj?.Description?.lineIndex ?? 0;
            const quantityLineIndex = obj?.Quantity?.lineIndex ?? 0;
            const unitPriceLineIndex = obj?.UnitPrice?.lineIndex ?? 0;

            const possibleIndexes = [
                amountLineIndex,
                descriptionLineIndex,
                quantityLineIndex,
                unitPriceLineIndex
            ].filter((index) => index !== undefined);

            if (possibleIndexes.length > 0 && Math.max(...possibleIndexes) > largestIndex) {
                largestIndex = Math.max(...possibleIndexes);
            }
        });

        return largestIndex;
    };

    // Define validateRecoveries using useCallback
    const validateRecoveries = useCallback(() => {
        if (!isCrewRecovery) return;

        const populatedRecoveryArray = recoveryData.map((recovery) => ({
            LineIndex: recovery?.RecoveryPCN?.lineIndex ?? recovery?.RecoveryServiceType?.lineIndex ?? recovery?.RecoveryType?.value ?? recovery?.RecoveryVesselName?.lineIndex ?? recovery?.RecoverySeafarerName?.lineIndex ?? recovery?.RecoveryAmount?.lineIndex ?? recovery?.RecoveryOneTime?.lineIndex ?? recovery?.RecoveryFI?.lineIndex,
            RecoveryPCN: getKeyValue(recovery?.RecoveryPCN),
            RecoveryVesselName: getKeyValue(recovery?.RecoveryVesselName),
            RecoverySeafarerName: getKeyValue(recovery?.RecoverySeafarerName),
            RecoveryServiceType: getKeyValue(recovery?.RecoveryServiceType),
            RecoveryVesselId: getKeyValue(recovery?.RecoveryVesselId),
            RecoveryType: getKeyValue(recovery?.RecoveryType),
            RecoveryAmount: getKeyValue(recovery?.RecoveryAmount),
            RecoveryOneTime: getKeyValue(recovery?.RecoveryOneTime),
            RecoveryFI: getKeyValue(recovery?.RecoveryFI),
            RecoveryValid: (
                getKeyValue(recovery?.RecoveryType) !== null &&
                getKeyValue(recovery?.RecoveryServiceType) !== null &&
                (
                    getKeyValue(recovery?.RecoveryPCN) !== null ||
                    getKeyValue(recovery?.RecoveryVesselName) !== null ||
                    getKeyValue(recovery?.RecoverySeafarerName) !== null
                )
            )
        }));

        const invalidRecoveries = populatedRecoveryArray?.filter((item) => item !== undefined && !item.RecoveryValid);
        const validRecoveries = populatedRecoveryArray?.filter((item) => item !== undefined && item.RecoveryValid)

        /*
        * [RG] Need to check what item triggers this
        */
        const errorRecord = invalidRecoveries !== undefined && invalidRecoveries.length === 1 && invalidRecoveries[0].RecoveryPCN === "" && invalidRecoveries[0].RecoveryType === null && invalidRecoveries[0].LineIndex === 0

        if (invalidRecoveries.length > 0 && !errorRecord) {
            throw new Error("Invalid recoveries found. Please ensure a recovery type/data has been selected for all recoveries.");
        }

        if (validRecoveries.length > 1 && !errorRecord) {

            const subTotal = convertStringToFloat(findData("SubTotal"));

            // Calculate the sum of RecoveryAmount in validRecoveries
            const totalRecoveryAmount = validRecoveries.reduce((sum, item) => {
                // Ensure RecoveryAmount is a number or treat it as 0 if undefined or null
                return sum + (parseFloat(item.RecoveryAmount) || 0);
            }, 0);

            // Check if totalRecoveryAmount equals the subtotal
            const isAmountValid = totalRecoveryAmount === subTotal;

            if (!isAmountValid) {
                throw new Error(`Invalid recoveries found. Please ensure the summation of the 'recovery amounts' (${totalRecoveryAmount.toFixed(2)}) is equal to the 'Sub Total' (${subTotal})`);
            }
        }
    }, [recoveryData, isCrewRecovery, supplierDetails]);

    // Define consolidatedLineChecks using useCallback
    const consolidatedLineChecks = useCallback(() => {

        if (!isConsolidatedDetailLines || isCrewRecovery) return;

        const item = findItem("InvoiceDescription", invoiceDetailData)
        const errorRecord = item !== undefined && item !== null && getKeyValue(item) !== null && getKeyValue(item) !== ""

        if (!errorRecord) {
            throw new Error("Invoice Detail Description missing.");
        }
    }, [invoiceDetailData]);

    useEffect(() => {
        try {
            if (supplierDetails?.isRecoverySupplier ?? false) {
                validateRecoveries();
            }
        } catch (error) {
            notification.error({
                message: "Error",
                description: error.message,
            });
        }
    }, [supplierDetails, validateRecoveries]);

    useEffect(() => {
        const newSubTotal = safeParseFloat(findData("SubTotal"));
        const newDiscount = safeParseFloat(findData("TotalDiscount"));
        const newTotalTax = safeParseFloat(findData("TotalTax"));
        const newFreight = safeParseFloat(findData("Freight"));
        const newPackaging = safeParseFloat(findData("Packaging"));
        const newInvoiceTotal = safeParseFloat(findData("InvoiceTotal"));
        const totalValue = total ? Number(total) : 0;
        const newRoundedTotal = roundValues ? Math.round(totalValue).toFixed(2) : totalValue.toFixed(2);

        setSubTotal(newSubTotal);
        setDiscount(newDiscount);
        setTotalTax(newTotalTax);
        setFreight(newFreight);
        setPackaging(newPackaging);
        setInvoiceTotal(newInvoiceTotal);
        setRoundedTotal(newRoundedTotal);
    }, [total, roundValues, findData, invoiceDetailData]);

    const handleAddInput = (i) => {

        let index = findLargestLineIndex(invoiceGetData);

        const newData = [
            ...invoiceGetData,
            {
                Amount: {
                    id: 0,
                    key: "Amount",
                    type: "Currency",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                Description: {
                    id: 0,
                    key: "Description",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                Quantity: {
                    id: 0,
                    key: "Quantity",
                    type: "Double",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                UnitPrice: {
                    id: 0,
                    key: "UnitPrice",
                    type: "Currency",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
            },
        ];

        setInvoiceGetData(newData);
    };

    const handleDeleteInput = (e, index) => {

        let data = invoiceGetData[index];

        const deletedIds = Object.values(data).filter((item) => item !== undefined).map((item) => {
            return {id: item.id, updatedBy: user?.email};
        });

        setInvoiceGetData((prevData) => {
            const newData = [...prevData];
            newData.splice(index, 1);
            return newData;
        });
        deleteInvoiceDetailData(deletedIds);
    };
    const handleDeleteTaxInput = (e, index) => {

        let data = taxItems[index];
        const deletedIds = Object.values(data)
            .filter(item => item && item !== undefined && item.id !== undefined)  // Ensure item and item.id are valid
            .map(item => ({id: item.id, updatedBy: user?.email}));

        setTaxItems((prevData) => {
            const newData = [...prevData];
            newData.splice(index, 1);
            return newData;
        });
        deleteInvoiceDetailData(deletedIds);
    }

    const updateDetailData = (id, value) => {
        if (id === "PurchaseOrderNumber" || id === "PurchaseOrder") {
            fetchPurchaseOrder();
        }

        if (id === "InvoiceDocumentClassificationId") {
            const currentValue = findData("InvoiceDocumentClassificationId");

            updateCostLines(value)

            if (value === "1") {
                notification.warning({
                    message: "Warning",
                    description: (
                        <>
                            <div>
                                Invoice Type has been changed to Credit Note. All total values have been updated to be
                                negative.
                            </div>
                        </>
                    ),
                });
            } else if (currentValue === "1" && value !== "1") {
                notification.warning({
                    message: "Warning",
                    description: (
                        <>
                            <div>
                                Invoice Type has been changed from Credit Note. All total values have been updated to be
                                positive
                            </div>
                        </>
                    ),
                });
            }
        }
        // Reset the isDraftClickedRef.current flag to false
        isDraftClickedRef.current = false;

        // Find the index of the data with the specified 'id' in the invoiceDetailData array
        const index = invoiceDetailData.findIndex((item) => item.key === id);

        if (index > -1) {
            // Data with 'id' exists in the array, update its 'correctedValue'
            let data = invoiceDetailData[index];
            data.correctedValue = value;

            if (data.correctedValue) {
                // Set a CSS class for highlighting with a yellow border if 'correctedValue' is not empty
                data.className = "border-yellow-500	";
            } else {
                data.className = "border	";
            }
            // Update the data in the invoiceDetailData array
            invoiceDetailData[index] = data;
            // Update the state with the modified invoiceDetailData array
            setInvoiceDetailData([...invoiceDetailData]);
            // Find the index of the data with the same 'id' in the updatedDataRef.current array

            const updateIndexx = updatedDataRef.current.findIndex((item) => item.key === id);
            if (updateIndexx > -1) {
                // Update the value and 'updatedBy' in updatedDataRef.current if data with the same 'id' exist
                updatedDataRef.current[updateIndexx].value = value;
                updatedDataRef.current[updateIndexx].updatedBy = user?.email;

            } else {
                // Add new data to updatedDataRef.current if no data with the same 'id' exists
                updatedDataRef.current.push({
                    id: data.id,
                    type: data.type,
                    key: data.key,
                    lineIndex: data.lineIndex,
                    value: value,
                    updatedBy: user?.email,
                    confidencePercent: 100,
                });
                setUpdatedDataCount(updatedDataRef.current.length);
            }
        } else {
            let nameData = null;
            const keysIds = new Set([
                "CoyId",
                "CurrencyId",
                "CustomerAddress",
                "CustomerAddressRecipient",
                "CustomerName",
                "CustomerType",
                "DepartmentId",
                "TotalDiscount",
                "DueDate",
                "FNNetValue",
                "FNTaxCodeId",
                "Freight",
                "InvoiceDate",
                "InvoiceDescription",
                "InvoiceHeaderDescription",
                "InvoiceDocumentClassificationId",
                "InvoiceId",
                "InvoiceTotal",
                "IsCrewRecovery",
                "IsMasterAndOwners",
                "IsMultiCompany",
                "IsProformaInvoice",
                "Packaging",
                "PaymentTermDays",
                "PurchaseOrder",
                "PurchaseOrderNumber",
                "ShippingAddress",
                "ShippingAddressRecipient",
                "SubTotal",
                "SupplierId",
                "SupplierName",
                "TotalTax",
                "VesselName"
            ]);
            if (keysIds.has(id)) {
                nameData = {
                    id: 0,
                    type: typeObject[id],
                    key: id,
                    lineIndex: null,
                    correctedValue: value,
                    updatedBy: user?.email,
                    confidencePercent: 100,
                };
            }

            if (nameData) {
                invoiceDetailData.push(nameData);
                setInvoiceDetailData([...invoiceDetailData]);
            }

            const updateIndex = updatedDataRef.current.findIndex((item) => item.key === id);
            if (updateIndex > -1) {
                updatedDataRef.current[updateIndex].value = value;

            } else {
                updatedDataRef.current.push({
                    id: 0,
                    type: typeObject[id],
                    key: id,
                    lineIndex: null,
                    value: value,
                    updatedBy: user?.email,
                    confidencePercent: 100,
                });
                setUpdatedDataCount(updatedDataRef.current.length);
            }
        }
    };

    const updateCostLines = (value) => {

        const invoiceTypes = [0, 2, 3]
        const costLineKeys = ["Amount", "UnitPrice"]
        const invoiceLineKeys = ["SubTotal", "InvoiceTotal", "TotalTax"]
        const costLines = invoiceDetailData.filter((item) => item !== undefined && ((costLineKeys.includes(item.key) && item.index !== null) || invoiceLineKeys.includes(item.key)))

        if (costLines) {
            costLines.filter((item) => item !== undefined)
                .forEach((item) => {
                    /*
          * [RG] Item value is alreay -ve or +ve based on selection. Return.
          */
                    if ((invoiceTypes.includes(value) && parseFloat(getKeyValue(item)) > 0) || (value === 1 && parseFloat(getKeyValue(item)) < 0)) {
                        return;
                    }

                    /*
                     * [RG] Item is +ve selection and total -ve
                     */
                    if ((invoiceTypes.includes(parseInt(value)) && parseFloat(getKeyValue(item)) < 0)) {
                        item.correctedValue = (parseFloat(getKeyValue(item)) * -1).toString();
                        saveCostLineChanges(item, costLineKeys, invoiceLineKeys);
                    }

                    /*
                     * [RG] Item is -ve selection and total +ve
                     */
                    if (parseInt(value) === 1 && parseFloat(getKeyValue(item)) > 0) {
                        item.correctedValue = (parseFloat(getKeyValue(item)) * -1).toString();
                        saveCostLineChanges(item, costLineKeys, invoiceLineKeys);
                    }
                });
        }
    };

    const saveCostLineChanges = (kvp, costLineKeys, invoiceLineKeys) => {

        if (costLineKeys.includes(kvp.key)) {

            /*
             * [RG] Find the index item
             */
            const itemIndex = invoiceGetData.findIndex((item) => item[kvp.key]?.key === kvp.key && item[kvp.key]?.lineIndex === kvp.lineIndex);

            updateInputDetailChange(kvp.key, itemIndex, kvp.correctedValue);
        }

        if (invoiceLineKeys.includes(kvp.key)) {
            updateDetailData(kvp.key, kvp.correctedValue);
        }
    };

    const DueDatecontent = (
        <div>
            <div className="w-full flex items-center">
                <div className="text-[13px]">Source:</div>
                <div className="pl-1  flex items-center  text-[14px] font-semibold">
                    {findData("InvoiceDueDateMethod")}
                </div>
            </div>
            <div className="w-full flex items-center ">
                <div className="text-[13px]">Term:</div>
                <div className="pl-1  flex items-center  text-[14px] font-semibold">
                    {findData("PaymentTermDays")}
                </div>
            </div>
            <div className="w-full flex items-center ">
                <div className="text-[13px]">Rule:</div>
                <div className="pl-1  flex items-center  text-[14px] font-semibold">
                    {supplierDetails?.isMarcasSupplier ? "Marcas" : "ShipSure"}
                </div>
            </div>
        </div>
    );
    const handleInputChange = (e, i) => {

        if (e.target.id === "PaymentTermDays") {
            if (findData("InvoiceDate")) {
                const parsedInvoiceDate = dayjs(findData("InvoiceDate"), "DD/MM/YYYY", true);
                const formattedInvoiceDate = parsedInvoiceDate.isValid() ? parsedInvoiceDate.format('YYYY-MM-DD') : dayjs(findData("InvoiceDate")).format('YYYY-MM-DD');

                updateDueDate(formattedInvoiceDate, e.target.value);
            }
        }
        updateDetailData(e.target.id, e.target.value);
    };

    const handleInputDetailChange = (e, index) => {
        isDraftClickedRef.current = false;
        updateInputDetailChange(e.target.id, index, e.target.value)
    };

    const updateInputDetailChange = (id, index, value) => {

        let data = invoiceGetData[index];

        if (data === undefined) return;

        // Check if the data for the current input field does not exist and initialize it
        if (!data[id]) {
            data[id] = {
                confidencePercent: 100,
                key: id,
                lineIndex: index,
                type: typeObject[id],
                id: 0
            };
        }
        // Update the 'correctedValue' of the data with the input value
        data[id].correctedValue = value;
        if (data[id].correctedValue) {
            data[id].className = "border-yellow-400	";
        } else {
            data[id].className = "border	";
        }
        // If 'value' is not set in the data, assign the input value to it
        if (!data[id].value) data[id].value = value;
        invoiceGetData[index] = data;
        // Update the state with the modified invoiceGetData array
        setInvoiceGetData([...invoiceGetData]);
        // Find the index of the data in updatedDataRef.current with the same 'key' and 'lineIndex'
        const updateIndex = updatedDataRef.current.findIndex(
            (item) =>
                item.key === data[id].key &&
                item.lineIndex === data[id].lineIndex &&
                item.id === (data[id]?.id ?? 0)
        );

        if (updateIndex > -1) {
            // Update the 'value' and 'updatedBy' in updatedDataRef.current if data with the same 'key' and 'lineIndex' exists
            updatedDataRef.current[updateIndex].value = value;
            updatedDataRef.current[updateIndex].updatedBy = user?.email;
        } else {
            updatedDataRef.current.push({
                id: data[id].id ?? 0,
                type: data[id].type,
                key: data[id].key,
                lineIndex: data[id].lineIndex,
                value: data[id].correctedValue,
                correctedValue: data[id].correctedValue,
                updatedBy: user?.email,
                confidencePercent: 100,
            });
            setUpdatedDataCount(updatedDataRef.current.length);
        }
    };

    const handleInputBankingChange = (e, index, value) => {
        setBankValues((prevBankValues) => ({
            ...prevBankValues,
            [e.target.id]: e.target.value,
        }));
        isDraftClickedRef.current = false;
        let data = ocrBankDetails[index];

        if (!data[e.target.id]) {
            data[e.target.id] = {
                confidencePercent: 100,
                key: e.target.id,
                lineIndex: index,
                type: typeObject[e.target.id],
            };
        }
        data[e.target.id].correctedValue = e.target.value;
        if (data[e.target.id].correctedValue) {
            data[e.target.id].className = "border-yellow-400	";
        } else {
            data[e.target.id].className = "border	";
        }

        if (!data[e.target.id].value) data[e.target.id].value = e.target.value;
        ocrBankDetails[index] = data;

        setOcrBankDetails([...ocrBankDetails]);
        const updateIndex = updatedDataRef.current.findIndex(
            (item) =>
                item.key === data[e.target.id].key &&
                item.lineIndex === data[e.target.id].lineIndex
        );

        if (updateIndex > -1) {
            updatedDataRef.current[updateIndex].value = e.target.value;
            updatedDataRef.current[updateIndex].updatedBy = user?.email;
        } else {
            updatedDataRef.current.push({
                id: data[e.target.id].id || 0,
                type: data[e.target.id].type,
                key: data[e.target.id].key,
                lineIndex: data[e.target.id].lineIndex,
                value: data[e.target.id].correctedValue,
                updatedBy: user?.email,
                confidencePercent: 100,
            });
            setUpdatedDataCount(updatedDataRef.current.length);
        }
    };

    const handleRecoveryValue = (index) => {

        let data = recoveryData[index];

        const possibleIndexes = [
            data?.RecoveryServiceType?.lineIndex,
            data?.RecoveryType?.lineIndex,
            data?.RecoveryVesselName?.lineIndex,
            data?.RecoveryPCN?.lineIndex,
            data?.RecoveryAmount?.lineIndex,
            data?.RecoveryOneTime?.lineIndex,
            data?.RecoverySeafarerName?.lineIndex,
            data?.RecoveryVesselId?.lineIndex,
            data?.RecoveryFI?.lineIndex,
        ].filter((index) => index !== undefined);

        const idx = Math.max(...possibleIndexes) ?? index;
        const recoveryTypeKey = "RecoveryType";
        const recoveryServiceTypeKey = "RecoveryServiceType";

        const currentRecoveryType = findIndexData(recoveryTypeKey, idx);
        const currentRecoveryServiceType = findIndexData(recoveryServiceTypeKey, idx);

        if (currentRecoveryType !== null && currentRecoveryServiceType !== null) {
            return currentRecoveryType;
        }

        const selectedRecoveryType = getKeyValue(recoveryData[index]?.[recoveryTypeKey]);
        const selectedRecoveryServiceType = getKeyValue(recoveryData[index]?.[recoveryServiceTypeKey]);

        if (selectedRecoveryType === null && selectedRecoveryServiceType === null && recoveryType.length > 1) {
            return null;
        }

        const keys = [
            {
                id: recoveryTypeKey,
                value: recoveryType.length === 1 ? recoveryType[0].value : selectedRecoveryType
            },
            {
                id: recoveryServiceTypeKey,
                value: recoveryType.length === 1 ? recoveryType[0].label : selectedRecoveryServiceType
            }]


        keys.forEach((item) => {
            const id = item.id;

            if (!data[id]) {
                data[id] = {
                    confidencePercent: 100,
                    key: item.id,
                    lineIndex: index,
                    value: "",
                    type: typeObject[id],
                };
            }

            if (data[id].correctedValue) {
                data[id].className = "border-yellow-400	";
            } else {
                data[id].className = "border	";
            }

            if (data[id].value !== "") {
                data[id].correctedValue = item.value;
            } else {
                data[id].value = item.value;
            }

            recoveryData[index] = data;

            const updateIndex = updatedDataRef.current.findIndex(
                (item) =>
                    item.key === id && item.lineIndex === idx
            );

            if (updateIndex > -1) {
                updatedDataRef.current[updateIndex].value = item.value;
                updatedDataRef.current[updateIndex].updatedBy = user?.email;

            } else {
                const addRecovery = {
                    id: data[id]?.id || 0,
                    type: typeObject[id],
                    key: item.id,
                    lineIndex: idx,
                    value: item?.value,
                    updatedBy: user?.email,
                    confidencePercent: 100,
                };

                updatedDataRef.current.push(addRecovery);
                setUpdatedDataCount(updatedDataRef.current.length);
            }
        });
        return recoveryType.length === 1 ? recoveryType[0].value : selectedRecoveryType;
    };

    const handleSelectRecoveryTypeChange = (value, item, index) => {
        handleInputRecoveryChange('RecoveryServiceType', item.label, index);
        handleInputRecoveryChange('RecoveryType', value, index);
    };

    const handleInputRecoveryChange = (id, value, index) => {
        isDraftClickedRef.current = false;

        let data = recoveryData[index];

        if (!data[id]) {
            data[id] = {
                confidencePercent: 100,
                key: id,
                lineIndex: index,
                type: typeObject[id],
            };
        }

        if (data[id].correctedValue) {
            data[id].className = "border-yellow-400	";
        } else {
            data[id].className = "border	";
        }

        if (data[id].value !== "") {
            data[id].correctedValue = value;
        } else {
            data[id].value = value;
        }
        recoveryData[index] = data;

        const updateIndex = updatedDataRef.current.findIndex(
            (item) =>
                item.key === data[id].key && item.lineIndex === data[id].lineIndex
        );

        if (updateIndex > -1) {
            updatedDataRef.current[updateIndex].value = value;
            updatedDataRef.current[updateIndex].updatedBy = user?.email;

        } else {
            const addRecovery = {
                id: data[id]?.id || 0,
                type: data[id].type,
                key: data[id].key,
                lineIndex: data[id].lineIndex,
                value: value,
                updatedBy: user?.email,
                confidencePercent: 100,
            };

            updatedDataRef.current.push(addRecovery);
            setUpdatedDataCount(updatedDataRef.current.length);
        }

        setRecoveryData([...recoveryData]);
    };
    const handleInputRecoveryChangeData = (e, index) => {
        handleInputRecoveryChange(e.target.id, e.target.value, index);
    };

    const handleInputTaxItems = (e, index) => {
        handleInputTaxtItemsChange(e.target.id, e.target.value, index)
    }

    const handleInputTaxtItemsChange = (id, value, index) => {
        isDraftClickedRef.current = false;

        let data = taxItems[index];

        if (!data[id]) {
            data[id] = {
                confidencePercent: 100,
                key: id,
                lineIndex: index,
                type: typeObject[id],
            };
        }

        if (data[id].correctedValue) {
            data[id].className = "border-yellow-400	";
        } else {
            data[id].className = "border	";
        }

        if (data[id].value !== "") {
            data[id].correctedValue = value;
        } else {
            data[id].value = value;
        }
        taxItems[index] = data;

        setTaxItems([...taxItems]);
        const updateIndex = updatedDataRef.current.findIndex(
            (item) =>
                item.key === data[id].key && item.lineIndex === data[id].lineIndex
        );

        if (updateIndex > -1) {
            updatedDataRef.current[updateIndex].value = value;
            updatedDataRef.current[updateIndex].updatedBy = user?.email;
        } else {
            updatedDataRef.current.push({
                id: data[id]?.id,
                type: data[id].type,
                key: data[id].key,
                lineIndex: data[id].lineIndex,
                value: value,
                updatedBy: user?.email,
                confidencePercent: 100,
            });
            setUpdatedDataCount(updatedDataRef.current.length);
        }

    };

    const updateInvoice = async () => {
        pcnDataArrayRef.current = [];
        setloading(true);

        const itemsToUpdate = updatedDataRef.current.filter((item) => item.updatedBy !== undefined);

        if (itemsToUpdate.length <= 0) {
            updatedDataRef.current = [];
            setUpdatedDataCount(0);
            setloading(false);
            return true;
        }

        return SharedService.put({
            token,
            url: `kvp/${id}`,
            data: itemsToUpdate,
        })
            .then(() => {
                updatedDataRef.current = [];
                setUpdatedDataCount(0);
                setRecoveryData([]);

                fetchOutcome();
                invoicePdfData();
                isDraftClickedRef.current = true;

                notification.success({
                    message: "Invoice Updated Successfully",
                });

                setloading(false);
                return true;
            })
            .catch((error) => {
                setloading(false);

                updatedDataRef.current = [];
                setUpdatedDataCount(0);
                if (error.response && error.response.status === 500) {
                    notification.error({
                        message: "Error",
                        description: error.response?.statusText,
                    });
                }
                if (error.response && error.response.status === 502) {
                    notification.error({
                        message: "Error",
                        description: error.response?.statusText,
                    });
                }
                return false;
            });
    };

    const validatedButtonInvoice = () => {
        setloading(true);

        validatedDataRef.current = validatedDataRef.current.filter((item) => item.updatedBy !== undefined);

        return SharedService.put({
            token,
            url: `kvp/${id}`,
            data: validatedDataRef.current,
        })
            .then(() => {
                validatedDataRef.current = [];
                invoicePdfData();

                notification.success({
                    message: "Bank Details Validated Successfully",
                });

                setloading(false);
                return true;
            })
            .catch((error) => {
                setloading(false);

                updatedDataRef.current = [];
                setUpdatedDataCount(0);
                notification.error({
                    message: error?.response?.data?.errors[0]?.errorMessage,
                });
                return false;
            });
    };

    const updateInvoiceStatus = async () => {
        try {
            const response = await SharedService.patch({
                token,
                url: "document",
                data: {
                    id: id,
                    status: "InvoiceCreated",
                    updatedBy: user?.email,
                },
            });

            notification.success({
                message: "Invoice Created",
            });
            if (response) {
                navigate("/invoice");
            }
            setloading(false);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
            notification.error({
                message: error?.response?.data?.errors[0]?.message,
            });
            console.error(error);
        }
    };
    const updateInvoiceStatusAfterSave = async () => {
        try {
            await SharedService.patch({
                token,
                url: "document",
                data: {
                    id: id,
                    status: "UnderReview",
                    updatedBy: user?.email,
                },
            });

            setloading(false);
        } catch (error) {
            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response?.statusText,
                });
            }
            console.error(error);
        }
    };

    const checkIsAllowedCurrency = useCallback(() => {
        const selectedCurrency = findData("CurrencyId");

        const supplier = supplierDetails;

        const isAllowedCurrency = companyAllowedCurrencies.some((item) => item !== undefined && item.id === selectedCurrency)

        if (!isAllowedCurrency) {
            throw new Error(`Selected Currency ${selectedCurrency} is not available to supplier ${supplier?.name}.`);
        }
    }, [companyAllowedCurrencies, supplierDetails, findData]);

    const checkSupplier = useCallback(() => {

        const supplier = supplierDetails;

        if (!supplier || supplier.length === 0) {
            throw new Error(`Please select a supplier before submitting an invoice.`);
        }
    }, [supplierDetails]);

    const invoiceChecks = useCallback(async () => {
        checkSupplier();
        checkIsAllowedCurrency();
        validateRecoveries();
        consolidatedLineChecks();


    }, [checkSupplier, checkIsAllowedCurrency, validateRecoveries, consolidatedLineChecks]);

    const handleDraftClick = async () => {
        try {
            await invoiceChecks();
            let reloadAttachments = false;

            if (fileList.length > 0) {
                await handleAttachmentSubmisson();
                reloadAttachments = true;
            }

            if (deleteAttachmentsList.length > 0 ){
                await handleAttachmentDelete();
                reloadAttachments = true;
            }

            if (reloadAttachments) {
                await mergeAttachments();
            }

            // If no error thrown, continue with other logic
            countRef.current = countRef.current + 1;
            await updateInvoice();

            if (countRef.current === 1 && updatedDataRef.current.length > 0) {
                await updateInvoiceStatusAfterSave();
            }
            updatedDataRef.current = [];
            setUpdatedDataCount(0);

        } catch (error) {

            notification.error({
                message: "Error",
                description: error.message,
            });
        }
    };


    const notifyVfcForOnHold = async (primaryContact) => {
        const vfcName =
            primaryContact?.user?.name
            || [primaryContact?.user?.firstName, primaryContact?.user?.lastName].filter(Boolean).join(" ")
            || primaryContact?.user?.email
            || "the VFC";

        try {
            const currentUserEmail = userRef.current?.email || user?.email;
            await SharedService.patch({
                token,
                url: "document",
                data: {
                    id: id,
                    status: ProcessingStatusEnum.OnHold,
                    requiresVFCApproval: true,
                    comment: `Placed 'On Hold' and notified the VFC ${vfcName}.`,
                    updatedBy: currentUserEmail,
                    pageContext: {
                        url: window.location.href,
                    },
                },
            });
            notification.success({
                message: "Invoice placed on hold",
                description: `${vfcName} has been notified for approval.`,
            });
        } catch (error) {
            notification.error({
                message: "Failed to notify VFC",
                description: error?.response?.data?.message
                    || error?.response?.data?.errors?.[0]?.message
                    || error?.message
                    || "Please try again.",
            });
        }
    };

    const showVesselMgmtWarning = (endDate, daysSince, primaryContact) => {
        Modal.warning({
            title: "Vessel no longer under management",
            centered: true,
            width: 540,
            okText: "Got it",
            content: (
                <div style={{padding: "8px 4px 4px"}}>
                    <p style={{margin: "0 0 14px", lineHeight: 1.55}}>
                        This vessel left management on{" "}
                        <strong>{endDate.format("DD-MMM-YYYY")}</strong>{" "}
                        ({daysSince} days ago).
                    </p>
                    <p style={{margin: "0 0 16px", lineHeight: 1.55}}>
                        Please contact the VFC ({VFC_RESPONSIBILITY_NAME}) before proceeding.
                    </p>
                    {primaryContact?.user ? (
                        <div style={{
                            background: "#F7F8FB",
                            border: "1px solid #E4E7EE",
                            borderRadius: 10,
                            padding: "16px 18px",
                        }}>
                            <div style={{fontSize: 11, textTransform: "uppercase", letterSpacing: ".4px", color: "#7A849A", marginBottom: 8}}>
                                {VFC_RESPONSIBILITY_NAME}
                                {primaryContact.departmentId && (
                                    <span style={{marginLeft: 6, color: "#A5ADBF"}}>· {primaryContact.departmentId}</span>
                                )}
                            </div>
                            <div style={{fontWeight: 600, color: "#0B1220", fontSize: 15}}>
                                {primaryContact.user.name
                                    || [primaryContact.user.firstName, primaryContact.user.lastName].filter(Boolean).join(" ")
                                    || "—"}
                            </div>
                            {primaryContact.user.email && (
                                <div style={{fontSize: 13, marginTop: 4}}>
                                    <a href={`mailto:${primaryContact.user.email}`} style={{color: "#1558B0"}}>
                                        {primaryContact.user.email}
                                    </a>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{
                            background: "#FFF4E0",
                            border: "1px solid #F0D89A",
                            color: "#9B6B00",
                            borderRadius: 10,
                            padding: "14px 16px",
                            fontSize: 13,
                            lineHeight: 1.55,
                        }}>
                            No {VFC_RESPONSIBILITY_NAME} is recorded for this vessel. Please reach out to the
                            assigned VFC for this vessel to confirm whether this invoice should still be processed.
                        </div>
                    )}
                </div>
            ),
        });
    };

    const findPrimaryPurchasingContact = (responsibilities) =>
        (responsibilities ?? []).find((r) => r?.name === VFC_RESPONSIBILITY_NAME);

    const isCurrentUserVfc = (primaryContact) => {
        const vfcEmail = primaryContact?.user?.email?.trim().toLowerCase();
        const meEmail = user?.email?.trim().toLowerCase();
        return !!vfcEmail && !!meEmail && vfcEmail === meEmail;
    };

    const clearVesselMgmt = () => {
        setVesselMgmtBlocked(false);
        setVesselMgmtInfo(null);
    };

    const checkVesselManagementStatus = async ({customerId, vesselManagementEndDate, vesselResponsibilities} = {}) => {
        const endDateRaw = vesselManagementEndDate ?? null;
        let responsibilities = vesselResponsibilities ?? null;

        // If autocomplete didn't include the end date, fall back to fetching the full customer.
        let evaluatedEnd = endDateRaw;
        if (!evaluatedEnd && customerId) {
            const customer = await fetchCustomerById(customerId);
            evaluatedEnd = customer?.vesselManagementEndDate ?? null;
            responsibilities = responsibilities ?? customer?.vesselResponsibilities ?? null;
        }

        if (!evaluatedEnd) {
            clearVesselMgmt();
            return;
        }

        const endDate = dayjs(evaluatedEnd);
        if (!endDate.isValid()) {
            clearVesselMgmt();
            return;
        }
        const daysSince = dayjs().startOf("day").diff(endDate.startOf("day"), "day");

        // Future end date or today — vessel still under management.
        if (daysSince <= 0) {
            clearVesselMgmt();
            return;
        }

        // Vessel is out of management — fetch responsibilities once so the label / modal can show the VFC.
        if (!responsibilities && customerId) {
            const customer = await fetchCustomerById(customerId);
            responsibilities = customer?.vesselResponsibilities ?? null;
        }
        const primaryContact = findPrimaryPurchasingContact(responsibilities);
        const userIsVfc = isCurrentUserVfc(primaryContact);

        if (daysSince <= 60|| userIsVfc) {
            // Either within the 60-day grace window OR the current user is the VFC.
            // Show the inline soft warning but don't block submission and don't surface the modal.
            setVesselMgmtBlocked(false);
            setVesselMgmtInfo({endDate, daysSince, primaryContact, userIsVfc});
            return;
        }

        // Past 60 days and user is not the VFC — block submission and surface the modal.
        setVesselMgmtBlocked(true);
        setVesselMgmtInfo({endDate, daysSince, primaryContact, userIsVfc: false});
        showVesselMgmtWarning(endDate, daysSince, primaryContact);
    };

    const validateCustomerVesselMgmt = async () => {
        const customerId = findData("CoyId");
        if (!customerId) return true;
        const customer = await fetchCustomerById(customerId);
        const endDateRaw = customer?.vesselManagementEndDate;
        if (!endDateRaw) {
            clearVesselMgmt();
            return true;
        }
        const endDate = dayjs(endDateRaw);
        if (!endDate.isValid()) {
            clearVesselMgmt();
            return true;
        }
        const daysSince = dayjs().startOf("day").diff(endDate.startOf("day"), "day");
        if (daysSince <= 0) {
            clearVesselMgmt();
            return true;
        }
        const primaryContact = findPrimaryPurchasingContact(customer?.vesselResponsibilities);
        const userIsVfc = isCurrentUserVfc(primaryContact);

        if (daysSince <= 60 || userIsVfc) {
            // Within grace window or the current user is the VFC — let submission proceed.
            setVesselMgmtBlocked(false);
            setVesselMgmtInfo({endDate, daysSince, primaryContact, userIsVfc});
            return true;
        }

        setVesselMgmtBlocked(true);
        setVesselMgmtInfo({endDate, daysSince, primaryContact, userIsVfc: false});
        showVesselMgmtWarning(endDate, daysSince, primaryContact);
        return false;
    };

    const validateInvoiceDate = () => {
        const invoiceDateRaw = findData("InvoiceDate");
        if (!invoiceDateRaw) return Promise.resolve(true);

        let invoiceDate = dayjs(invoiceDateRaw, "YYYY-MM-DD", true);
        if (!invoiceDate.isValid()) invoiceDate = dayjs(invoiceDateRaw, "DD/MM/YYYY", true);
        if (!invoiceDate.isValid()) invoiceDate = dayjs(invoiceDateRaw);
        if (!invoiceDate.isValid()) return Promise.resolve(true);

        const today = dayjs().startOf("day");
        const inv = invoiceDate.startOf("day");
        const daysDiff = inv.diff(today, "day");

        let warning = null;
        const formattedDate = inv.format("DD-MMM-YYYY");
        if (daysDiff > 0) {
            const days = daysDiff;
            warning = `Invoice Date is set to ${formattedDate}, which is ${days} day${days === 1 ? "" : "s"} in the future.`;
        } else if (daysDiff < -28) {
            const daysOld = Math.abs(daysDiff);
            warning = `Invoice Date is set to ${formattedDate}, which is ${daysOld} days old (over the 28-day threshold).`;
        }

        if (!warning) return Promise.resolve(true);

        return new Promise((resolve) => {
            Modal.confirm({
                title: "Confirm Invoice Date",
                content: `${warning} Are you sure you want to submit this invoice?`,
                okText: "Submit anyway",
                cancelText: "Cancel",
                centered: true,
                onOk: () => resolve(true),
                onCancel: () => resolve(false),
            });
        });
    };

    const validateFinanceTaxFields = () => {
        const isEmpty = (val) => val === null || val === undefined || `${val}`.trim() === "";
        const netValue = findData("FNNetValue");
        const taxCode = findData("FNTaxCodeId");
        const hasNetValue = !isEmpty(netValue);
        const hasTaxCode = !isEmpty(taxCode);

        if (hasNetValue && !hasTaxCode) {
            notification.error({
                message: "Validation Error",
                description: "Finance Tax Code is required when a Net Value is entered.",
            });
            return false;
        }

        if (hasTaxCode && !hasNetValue) {
            notification.error({
                message: "Validation Error",
                description: "Net Value is required when a Finance Tax Code is selected.",
            });
            return false;
        }

        return true;
    };

    const handleSubmitClick = async () => {
        if (!validateFinanceTaxFields()) return;

        const customerOk = await validateCustomerVesselMgmt();
        if (!customerOk) return;

        const invoiceDateOk = await validateInvoiceDate();
        if (!invoiceDateOk) return;

        if (supplierDetails?.companyAllowedCurrencies?.length > 1) {
            setIsCurrencyPopupVisible(true);
        } else {
            handleSubmit();
        }
    };

    const handleSubmit = async () => {
        try {
            setIsCurrencyPopupVisible(false);
            await invoiceChecks();

            if (isDraftClickedRef.current || (updatedDataRef.current.length === 0 && fileList.length === 0 && deleteAttachmentsList.length === 0)) {

                await submitToShipsure();
            } else {
                const updateStatus = await updateInvoice();

                if (updateStatus) {
                    await submitToShipsure();
                }
            }
        } catch (error) {

            notification.error({
                message: "Error",
                description: error.message,
            });
        }
    };

    const submitToShipsure = async () => {
        setloading(true);
        try {
            const response = await SharedService.post({
                token,
                url: "invoice/create",
                data: {id: id},
            });
            if (response) {
                notification.success({
                    message: response.message,
                });
                await updateInvoiceStatus();
            }
        } catch (error) {
            console.error("InvoiceDetail Error:", error);
            setloading(false);
            if (error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error?.response?.statusText,
                });
            } else if (
                error.response.status === 400 &&
                error?.response?.data?.errors
            ) {
                notification.error({
                    message: "Error",
                    description: error?.response?.data?.errors[0]?.message,
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: "Error",
                    description: error?.response?.data?.message,
                });
            }

            console.error(error);
        }
    };

    const handleSupplierSearch = (value) => {
        setSupplierSearchText(value);
    };
    const handleAddRecovery = () => {
        let index = -1;

        if (recoveryData.length > 0) {
            const recoveryDatalength = recoveryData.length - 1;
            const data = recoveryData[recoveryDatalength];

            const possibleIndexes = [
                data?.RecoveryServiceType?.lineIndex,
                data?.RecoveryType?.lineIndex,
                data?.RecoveryVesselName?.lineIndex,
                data?.RecoveryPCN?.lineIndex,
                data?.RecoveryAmount?.lineIndex,
                data?.RecoveryOneTime?.lineIndex,
                data?.RecoverySeafarerName?.lineIndex,
                data?.RecoveryVesselId?.lineIndex,
                data?.RecoveryFI?.lineIndex,
            ].filter((index) => index !== undefined);

            if (possibleIndexes.length > 0) {
                index = Math.max(...possibleIndexes);
                setRecoveryIndex(index + 1);
            }
        }

        const newData = [
            ...recoveryData,
            {
                RecoveryPCN: {
                    id: 0,
                    key: "RecoveryPCN",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                RecoveryVesselName: {
                    id: 0,
                    key: "RecoveryVesselName",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                RecoverySeafarerName: {
                    id: 0,
                    key: "RecoverySeafarerName",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                RecoveryVesselId: {
                    id: 0,
                    key: "RecoveryVesselId",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                RecoveryAmount: {
                    id: 0,
                    key: "RecoveryAmount",
                    type: "Currency",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                RecoveryOneTime: {
                    id: 0,
                    key: "RecoveryOneTime",
                    type: "Bool",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                RecoveryFI: {
                    id: 0,
                    key: "RecoveryFI",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                }
            },
        ];

        setRecoveryData(newData);
    };
    const handleAddTaxItems = () => {
        let index = -1;

        if (taxItems.length > 0) {
            const taxItemslength = taxItems.length - 1;
            const data = taxItems[taxItemslength];

            const possibleIndexes = [
                data?.Tax?.lineIndex,
                data?.TaxRate?.lineIndex,
                data?.TaxType?.lineIndex,

            ].filter((index) => index !== undefined);

            if (possibleIndexes.length > 0) {
                index = Math.max(...possibleIndexes);
            }
        }


        const newData = [
            ...taxItems,
            {
                TaxType: {
                    id: 0,
                    key: "TaxType",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                TaxRate: {
                    id: 0,
                    key: "TaxRate",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                Tax: {
                    id: 0,
                    key: "Tax",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },

            },
        ];

        setTaxItems(newData);
    };

    const handleAddBankingOcr = () => {
        setIsAddBankPopup(true);

        const OcrBankDatalength = ocrBankDetails.length - 1;
        const data = ocrBankDetails[OcrBankDatalength];

        let index;
        if (ocrBankDetails.length <= 0) {
            index = -1;
        } else {
            if (data && data.SWIFT) index = data.SWIFT.lineIndex;
            else if (data && data.Accountnumber) index = data.Accountnumber.lineIndex;
            else if (data && data.IBAN) index = data.IBAN.lineIndex;
            else if (data && data.BankCurrencyCode)
                index = data.BankCurrencyCode.lineIndex;
            else if (data && data.IFSC) index = data.IFSC.lineIndex;
        }

        const newData = [
            ...ocrBankDetails,
            {
                Accountnumber: {
                    id: 0,
                    key: "Accountnumber",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                BankName: {
                    id: 0,
                    key: "BankName",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                SWIFT: {
                    id: 0,
                    key: "SWIFT",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                IFSC: {
                    id: 0,
                    key: "IFSC",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                IBAN: {
                    id: 0,
                    key: "IBAN",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                BankCurrencyCode: {
                    id: 0,
                    key: "BankCurrencyCode",
                    type: "Currency",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                SortCode: {
                    id: 0,
                    key: "SortCode",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
                BankAccountStatus: {
                    id: 0,
                    key: "BankAccountStatus",
                    type: "String",
                    confidencePercent: 100,
                    correctedValue: null,
                    lineIndex: index + 1,
                    value: "",
                },
            },
        ];

        setOcrBankDetails(newData);
    };

    const handlePopupClick = (e) => {
        e.stopPropagation();
    };

    const getDescriptionItem = (item, key) => {
        if (!item || !item[key]) return "";
        if (
            item &&
            item[key] &&
            item[key].correctedValue !== null &&
            item[key].correctedValue !== undefined
        ) {
            return item[key]?.correctedValue;
        }
        return item[key]?.value;
    };

    const getInvoiceRecoveryValue = (item, key) => {
        if (!item || !item[key]) return "";
        if (
            item &&
            item[key] &&
            item[key].value !== null &&
            item[key].value !== undefined
        ) {
            return item[key]?.value;
        }
    };

    const getShipsureValidatedCorrectedValue = (item, key) => {
        if (!item || !item[key]) return "";

        const correctedValue = getKeyValue(item[key]);
        return correctedValue !== null && correctedValue !== undefined
            ? correctedValue
            : null;
    };

    const formatNumberWithCommas = (number) => {
        return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    const roundToDecimalPlaces = (number, decimalPlaces) => {
        return Number(number.toFixed(decimalPlaces));
    };

    function getDescriptionWithInvalidTotal() {
        const invalidDescriptions = [];

        invoiceGetData.forEach((item) => {
            const quantity =
                parseFloat(getKeyValue(item?.Quantity)) ||
                1;
            const unitPrice = parseFloat(
                getKeyValue(item?.UnitPrice)
            );
            const totalData = parseFloat(
                getKeyValue(item?.Amount)
            );

            // Round the quantity, unitPrice, and totalData to 2 decimal places
            const roundedQuantity = parseFloat(quantity.toFixed(2));
            const roundedUnitPrice = parseFloat(unitPrice.toFixed(2));
            const roundedTotalData = parseFloat(totalData.toFixed(2));
            const calculatedTotal = parseFloat(
                (roundedQuantity * roundedUnitPrice).toFixed(2)
            );

            // Check if the calculated total (rounded) does not match the expected total (rounded)
            if (
                roundedQuantity &&
                roundedUnitPrice &&
                roundedTotalData &&
                calculatedTotal !== roundedTotalData
            ) {
                if (item?.Description?.value) {
                    invalidDescriptions.push(item.Description.value);
                }
            }
        });

        return invalidDescriptions;
    }

    const invalidDescriptions = useMemo(() => getDescriptionWithInvalidTotal(), [invoiceGetData]);

    const summarycontent = (
        <div>
            <div className="border-b">
                <div></div>
                <div>
                    Line Items <span
                    className="font-bold">Total: {formatNumberWithCommas(!isConsolidatedDetailLines ? amountSum : subTotal)}</span>
                </div>
                <div className="font-bold">SubTotal: {formatNumberWithCommas(subTotal)}</div>
                <div className="font-bold">Discount: {formatNumberWithCommas(discount)}</div>
                <div className="font-bold">Tax: {formatNumberWithCommas(totalTax)}</div>
                <div className="font-bold">Freight: {formatNumberWithCommas(freight)}</div>
                <div className="font-bold">Packaging: {formatNumberWithCommas(packaging)}</div>
                <div className="font-bold">Invoice Total: {formatNumberWithCommas(invoiceTotal.toFixed(2))}</div>
            </div>

            {subTotal !== amountSum && (
                <div className="border-b mt-1">
                    <div>
                        Line Items <span className="font-bold">Total: {formatNumberWithCommas(amountSum)}</span>
                        <p>Differs From Invoice Summary <span
                            className="font-bold">Sub Total: {formatNumberWithCommas(subTotal)}</span></p>
                    </div>
                </div>
            )}

            {total && invoiceTotal && (
                roundedTotal !== invoiceTotal.toFixed(2) && (
                    <div className="mt-1 border-b">
                        The <span className="font-bold">Invoice Total:</span> <span
                        className="font-bold">{formatNumberWithCommas(invoiceTotal.toFixed(2))}</span> does not match
                        with the (Subtotal - Discount + Tax + Freight + Packaging)
                        <span className="font-bold"> Value: {formatNumberWithCommas(roundedTotal)}</span>
                    </div>
                )
            )}

            {total && invoiceTotal && (
                <div className="mt-2">
                    <span className="font-bold">Difference:</span>
                    <span
                        className="pl-1 text-red-800">{formatNumberWithCommas((invoiceTotal - total).toFixed(2))}</span>
                </div>
            )}
        </div>
    );


    const content = (
        <div>
            {supplierOutcome?.length > 0 && (
                <>
                    <p>
                        <span className="font-extrabold">The Supplier Name:</span>{" "}
                        <span className="font-bold">{findData("SupplierName")}</span>
                    </p>
                    {findData("SupplierName") ? <p>Differs from</p> : <div></div>}
                    <p>
                        <span className="font-extrabold">OCR Supplier Name:</span>{" "}
                        <span className="font-bold">{supplierOutcome}</span>
                    </p>
                </>
            )}
        </div>
    );
    const headercontent = (
        <div>
            More than one Purchase orders are matched against the COYID{" "}
            <span>{purchaseOrderList[0]?.coyid}</span> and Supplier id{" "}
            <span>{purchaseOrderList[0]?.supplierName}</span>
        </div>
    );

    const handleInvoiceDateChange = (dates, dateStrings) => {
        const parsedInvoiceDate = dayjs(dates, "DD/MM/YYYY", true);
        const formattedInvoiceDate = parsedInvoiceDate.isValid() ? parsedInvoiceDate.format('YYYY-MM-DD') : dayjs(dates).format('YYYY-MM-DD')

        if (findData("DueDate")) {
            const parsedDueDate = dayjs(findData("DueDate"), "DD/MM/YYYY", true);
            const formattedDueDate = parsedDueDate.isValid() ? parsedDueDate.format('YYYY-MM-DD') : dayjs(findData("DueDate")).format('YYYY-MM-DD')

            calculatePaymentTermDays(formattedInvoiceDate, formattedDueDate);
        }

        updateDetailData("InvoiceDate", formattedInvoiceDate);
    };
    const handleDueDateChange = (dates, dateStrings) => {

        const parsedDueDate = dayjs(dates, "DD/MM/YYYY", true);
        const formattedDueDate = parsedDueDate.isValid() ? parsedDueDate.format('YYYY-MM-DD') : dayjs(dates).format('YYYY-MM-DD')

        updateDetailData("DueDate", formattedDueDate);
        updateDetailData("InvoiceDueDateMethod", "Manual");

        if (findData("InvoiceDate")) {
            const parsedInvoiceDate = dayjs(findData("InvoiceDate"), "DD/MM/YYYY", true);
            const formattedInvoiceDate = parsedInvoiceDate.isValid() ? parsedInvoiceDate.format('YYYY-MM-DD') : dayjs(findData("InvoiceDate")).format('YYYY-MM-DD')
            calculatePaymentTermDays(formattedInvoiceDate, formattedDueDate);
        }
    };

    const calculatePaymentTermDays = (invoiceDate, dueDate) => {
        const invoiceDateObj = dayjs(invoiceDate);
        const dueDateObj = dayjs(dueDate);

        let paymentTermDays = dueDateObj.diff(invoiceDateObj, "day");
        paymentTermDays = Math.abs(paymentTermDays);

        if (!isNaN(paymentTermDays)) {
            updateDetailData("PaymentTermDays", paymentTermDays);
        }
    };

    const updateDueDate = (invoiceDate, paymentTermDays) => {
        const invoiceDateObj = dayjs(invoiceDate);
        const dueDateObj = invoiceDateObj.add(paymentTermDays, "day");

        updateDetailData("DueDate", dueDateObj.format("YYYY-MM-DD"));
    };
    const handleSearchClick = (index) => {
        const updatedPopovers = [...popovers];
        updatedPopovers[index] = true;
        setPopovers(updatedPopovers);
    };

    const handleSearchInvoiceValidationClick = (items, index) => {
        const updatedPopovers = [...invoicePopovers];
        updatedPopovers[index] = true;
        setInvoicePopovers(updatedPopovers);
    };

    // Function to handle menu item click
    const handleMenuInvoiceValidationClick = (e, index) => {
        if (
            shipSureIndex !== null &&
            bankDetails[shipSureIndex] &&
            bankDetails[shipSureIndex].bankValidation !== null
        ) {
            bankDetails[shipSureIndex].bankValidation.bankValidationStatus =
                "Unvalidated";
            const updatedShipsureIconss = [...shipsureIcons];
            updatedShipsureIconss[shipSureIndex] = "Unvalidated";
            setShipsureIcons(updatedShipsureIconss);

            let updatedDataIndex = updatedDataRef.current.findIndex(
                (item) =>
                    item.key === "BankValidationStatus" &&
                    item.lineIndex === shipSureIndex
            );
            if (updatedDataIndex > -1) {
                updatedDataRef.current[updatedDataIndex].value = "Unvalidated";
                updatedDataRef.current[updatedDataIndex].updatedBy = user?.email;

            } else {
                updatedDataRef.current.push({
                    id: bankDetails[shipSureIndex].bankValidation
                        .bankValidationStatusKvpId,
                    type: "String",
                    key: "BankValidationStatus",
                    lineIndex: parseInt(shipSureIndex),
                    value: "Unvalidated",
                    updatedBy: user?.email,
                    confidencePercent: 100,
                });
            }
        }
        const updatedShipsureIcons = [...invoiceBankValidationIcons];
        updatedShipsureIcons[index] = e.key;
        setInvoiceBankValidationIcons(updatedShipsureIcons);
        const updatedPopovers = [...invoicePopovers];
        updatedPopovers[index] = false;
        setPopovers(updatedPopovers);
        InvoiceBankValidation(e, index);
    };
    // Function to handle menu item click
    const handleMenuClick = (e, index) => {
        const updatedShipsureIcons = [...shipsureIcons];
        updatedShipsureIcons[index] = e.key;
        setShipsureIcons(updatedShipsureIcons);
        const updatedPopovers = [...popovers];
        updatedPopovers[index] = false;
        setPopovers(updatedPopovers);
        shipsureBankValidation(e, index);
    };

    const InvoiceBankValidation = (e, index) => {
        let updatedDataIndex = updatedDataRef.current.findIndex(
            (item) => item.key === e.item.props.label && item.lineIndex === index
        );
        if (updatedDataIndex > -1) {
            updatedDataRef.current[updatedDataIndex].value = e.key;
            updatedDataRef.current[updatedDataIndex].updatedBy = user?.email;
        } else {
            updatedDataRef.current.push({
                id:
                    ocrBankDetails[index].InvoiceBankValidationStatus !== undefined
                        ? ocrBankDetails[index].InvoiceBankValidationStatus.id
                        : 0,
                type: typeObject[e.item.props.label],
                key: e.item.props.label,
                lineIndex: index,
                value: e.key,
                updatedBy: user?.email,
                confidencePercent: 100,
            });
        }
    };
    const shipsureBankValidation = (e, index) => {
        let updatedDataIndex = updatedDataRef.current.findIndex(
            (item) => item.key === e.item.props.label && item.lineIndex === index
        );

        if (updatedDataIndex > -1) {
            updatedDataRef.current[updatedDataIndex].value = e.key;
            updatedDataRef.current[updatedDataIndex].updatedBy = user?.email;
        } else {
            updatedDataRef.current.push({
                id:
                    bankDetails[index]?.bankValidation !== null
                        ? bankDetails[index]?.bankValidation?.bankValidationStatusKvpId
                        : 0,
                type: typeObject[e.item.props.label],
                key: e.item.props.label,
                lineIndex: index,
                value: e.key,
                updatedBy: user?.email,
                confidencePercent: 100,
            });
        }
        let updatedDataIdIndex = updatedDataRef.current.findIndex(
            (item) => item.key === "BankValidationId" && item.lineIndex === index
        );
        if (updatedDataIdIndex > -1) {
            updatedDataRef.current[updatedDataIdIndex].value = bankDetails[index].id;
            updatedDataRef.current[updatedDataIndex].updatedBy = user?.email;


        } else {
            updatedDataRef.current.push({
                id:
                    bankDetails[index]?.bankValidation !== null
                        ? bankDetails[index].bankValidation.bankValidationStatusKvpId
                        : 0,
                type: "String",
                key: "BankValidationId",
                lineIndex: index,
                value: bankDetails[index].id,
                updatedBy: user?.email,
                confidencePercent: 100,
            });
        }
    };
    const menu = (
        <Menu
            onClick={(e) =>
                handleMenuClick(
                    e,
                    popovers.findIndex((popover) => popover)
                )
            }
        >
            <Menu.Item
                key="Validated"
                icon={<CheckOutlined/>}
                className="flex items-center"
                label="BankValidationStatus"
            >
                Validated
            </Menu.Item>
            <Menu.Item
                key="Unvalidated"
                icon={<CloseOutlined/>}
                className="flex items-center"
                label="BankValidationStatus"
            >
                Unvalidate
            </Menu.Item>
        </Menu>
    );

    const InvoiceBankValidationmenu = () => (
        <Menu
            onClick={(e) =>
                handleMenuInvoiceValidationClick(
                    e,
                    invoicePopovers.findIndex((invoicePopover) => invoicePopover)
                )
            }
            onSelect={() => {
                setInvoicePopovers(invoicePopovers.map(() => false));
            }}
        >
            <Menu.Item
                key="NewBank"
                icon={<BankOutlined/>}
                className="flex items-center"
                label="InvoiceBankValidationStatus"
            >
                New Bank
            </Menu.Item>
            <Menu.Item
                key="DeselectNewBank"
                icon={<CloseOutlined/>}
                className="flex items-center"
                label="InvoiceBankValidationStatus"
            >
                Deselect New Bank
            </Menu.Item>
        </Menu>
    );

    const parseDate = (date) => {
        // Remove time zone offset from the date string
        const dateWithoutTimeZone = date.replace(
            /(\d{2}\/\d{2}\/\d{4})\s(\d{2}:\d{2}:\d{2})\s\+\d{2}:\d{2}/,
            "$1 $2"
        );

        // Try to parse the date with the first format
        const parsedDate1 = dayjs(dateWithoutTimeZone, "DD/MM/YYYY", true);
        if (parsedDate1.isValid()) {
            return parsedDate1;
        }

        // Try to parse the date with the second format
        const parsedDate2 = dayjs(dateWithoutTimeZone, "M/D/YYYY h:mm:ss A", true);
        if (parsedDate2.isValid()) {
            return parsedDate2;
        }

        // Try to parse the date with the third format
        const parsedDate3 = dayjs(dateWithoutTimeZone, "YYYY-MM-DD", true);
        if (parsedDate3.isValid()) {
            return parsedDate3;
        }

        // Try to parse the date with the fourth format
        const parsedDate4 = dayjs(dateWithoutTimeZone, "DD/MM/YYYY HH:mm:ss", true);
        if (parsedDate4.isValid()) {
            return parsedDate4;
        }

        // Handle the error or set a default value as needed
        return dayjs(date);
    };

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    const handleSupplierPopup = () => {
        setIsSupplierPopup(!isSupplierPopup);
    };


    const submitDisabledCheck = () => {

        const amountLineCheck = (isConsolidatedDetailLines || isCrewRecovery) ?
            findData("SubTotal") === null :
            ((amountSum &&
                findData("SubTotal") !== null &&
                amountSum !==
                convertStringToFloat(
                    findData("SubTotal")
                )
            ))

        const totalCheck = (total &&
            findData("InvoiceTotal") &&
            !roundValues &&
            roundToDecimalPlaces(total, 2) !==
            convertStringToFloat(
                findData("InvoiceTotal")
            )
        )

        const roundedTotalCheck = (roundValues && total && findData("InvoiceTotal") && Math.round(total).toFixed(2) !==
            parseFloat(
                removeAlphabetsFromString(
                    findData("InvoiceTotal")
                )).toFixed(2))

        const keysToUpdate = updatedDataRef.current.length > 0

        return (disableSubmit || amountLineCheck || keysToUpdate || (totalCheck || roundedTotalCheck) || vesselMgmtBlocked);
    }

    const subTotalClassName = () => {

        var classname = `h-10 text-right ${borderColor("SubTotal")}`;

        if ((isConsolidatedDetailLines || isCrewRecovery) && findData("SubTotal")) {
            return classname;
        }

        if (amountSum && findData("SubTotal") && convertStringToFloat(findData("SubTotal")) !== amountSum) {
            return "h-10 text-right border-red-600";
        }

        return classname;
    }

    /* START: MULTI Document Upload */

    const handleFileUpload = (options) => {
        const {onSuccess, onError, file} = options;
        setTimeout(() => {
            const isUploaded = Math.random() < 0.8;

            if (isUploaded) {
                // mark as success
                onSuccess?.("success");
                message.success(`${file.name.replace(/\.[^/.]+$/, "")} Uploaded`);
            } else {
                // mark as error
                onError?.(new Error("upload failed"));
                message.error(`${file.name} upload failed. Please upload it again`);

                // Optional: auto-remove failed file from UI
                setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
            }
        }, 1000);
    };

    const handleFileChange = (file, nextList) => {
        setFileList(nextList ?? []);
    };

    const handleRemoveFile = (file) => {
        setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
    };

    const handleReorder = (fromIndex, toIndex) => {
        setFileList(prev => {
            const updated = [...prev];

            const [moved] = updated.splice(fromIndex, 1);
            updated.splice(toIndex, 0, moved);

            const highestExistingOrder = Math.max(
                0,
                ...(uploadedAttachments ?? []).map(x => Number(x?.order) || 0)
            );

            return updated.map((file, index) => ({
                ...file,
                order: highestExistingOrder + index + 1
            }));
        });
    };

    const handleDeleteList = (id) => {
        setDeleteAttachmentsList(prev => [...prev, id]);
    };

    const handleAttachmentDelete = async () => {
        if (!deleteAttachmentsList || deleteAttachmentsList.length === 0) return;
        try {
            setloading(true);

            const results = await Promise.all(
                deleteAttachmentsList.map(async (id) => {
                    return await SharedService.delete({token: token, url: `attachment/${id}`});
                })
            );

            message.success(`Successfully deleted ${results.length} attachment(s).`);

            // Optional: clear after successful upload
            setloading(false);
            setDeleteAttachmentsList([]);

        } catch (error) {
            console.error("InvoiceDetail Error:", error);
            message.error("One or more attachments failed to Delete.");
        } finally {
            setloading(false);
        }
    }

    const handleAttachmentSubmisson = async () => {
        if (!fileList || fileList.length === 0) return;
        try {
            setloading(true);

            const results = await Promise.all(
                fileList.map(async (file, index) => {
                    const base64File = await convertFileToBase64(file.originFileObj);

                    if (!base64File) {
                        message.error(`${file.name} bytes not found`);
                        return;
                    }

                    const highestExistingOrder = Math.max(
                        0,
                        ...(uploadedAttachments ?? []).map(x => Number(x?.order) || 0)
                    );

                    const payload = {
                        base64File: base64File,
                        status: "Processed",
                        order: file?.order ?? highestExistingOrder + index + 1,
                        fileName: file.name,
                        fileType: file.type,
                        documentId: selectedItem.id,
                        attachmentType: AttachmentType.SupportingDocument,
                        uploadedBy: user?.email,
                    };

                    return await SharedService.post({token: token, url: "attachment", data: payload});
                })
            );

            message.success(`Successfully uploaded ${results.length} attachment(s).`);

            // Optional: clear after successful upload
            setloading(false);
            setFileList([]);

        } catch (error) {
            console.error(error);
            message.error("One or more attachments failed to upload.");
        } finally {
            setloading(false);
        }
    }

    const loadAttachments = async () => {
        try {
            const payload = {
                documentId: selectedItem.id,
                attachmentType: AttachmentType.SupportingDocument,
            };

            const response = await SharedService.post({
                token,
                url: "attachments/search",
                data: payload
            });

            setUploadedAttachments(response?.items ?? []);

        } catch (error) {

            message.error(
                error?.response?.data?.message ||
                "Failed to load attachments."
            );
            setUploadedAttachments([]);
        }
    };

    const mergeAttachments = async () => {
        try {
            const response = await SharedService.post({
                token,
                url: `document/${selectedItem.id}/merge`
            });

            setPdfData(response.base64File);
            setFile(response)
            loadAttachments()

        } catch (error) {
            message.error(
                error?.response?.data?.message ||
                "Merge Failed."
            );
        }
    };

    useEffect(() => {
        if (selectedItem?.id) {
            loadAttachments();
        }
    }, [selectedItem?.id]);

    /* END: MULTI Document Upload */

    isFormReadOnlyRef.current =
        selectedItem?.processingStatus === ProcessingStatusEnum.InvoiceCreated ||
        selectedItem?.processingStatus === ProcessingStatusEnum.Rejected;

    return (
        <div className="bg-[#F7F8FB] min-h-screen">
            <SEO {...pageSEOSettings} />
            <InvoiceHeader
                tableItemIndex={tableIndex}
                setlistPagination={setlistPagination}
                listPagination={listPagination}
                selectedRadioOption={selectedRadioOption}
                setinvoiceData={setinvoiceData}
                currentItemIndex={currentItemIndex}
                setCurrentItemIndex={setCurrentItemIndex}
                documentId={id}
                invoiceData={invoiceData}
                selectedItem={selectedItem}
                invoiceDetailData={invoiceDetailData}
            />
            <SupplierDetailsPopup
                Visible={isSupplierPopup}
                onClose={handleSupplierPopupClose}
                supplierDetails={supplierDetails}
            />
            <SupplierCurrencyPopup
                visible={isCurrencyPopupVisible}
                onClose={() => setIsCurrencyPopupVisible(false)}
                onClickAction={handleSubmit}
                supplierDetails={supplierDetails}
                selectedCurrency={findData("CurrencyId")}
            />
            <AddNewBankPopup
                Visible={isAddBankPopup}
                setIsAddBankPopup={setIsAddBankPopup}
                bankValues={bankValues}
                setBankValues={setBankValues}
                ocrBankDetails={ocrBankDetails}
                handleInputBankingChange={handleInputBankingChange}
            />

            <div className="grid grid-cols-12 gap-4 px-4 pb-6 relative">
                {loading && (
                    <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-10 rounded-[14px]">
                        <Spin size="large" className="custom-spin"/>
                    </div>
                )}

                <div
                    className={`col-span-12 ${isExpanded ? "lg:col-span-4" : "lg:col-span-6"} relative`}
                >
                    <Tooltip
                        placement="topRight"
                        title={isExpanded ? "Collapse PDF panel" : "Expand PDF panel"}
                    >
                        <button
                            type="button"
                            onClick={toggleExpand}
                            className="md:flex hidden absolute top-2 right-2 z-20 text-[12px] items-center gap-1.5 px-2.5 py-1 rounded-md bg-white/90 border border-[#E4E7EE] text-[#374152] hover:bg-white hover:text-[#0B1220] transition-colors shadow-sm"
                        >
                            {isExpanded ? <FullscreenExitOutlined/> : <FullscreenOutlined/>}
                            {isExpanded ? "Collapse" : "Expand"}
                        </button>
                    </Tooltip>
                    {url && file ? (
                        <FileViewer
                            file={file}
                            url={url}
                            loading={loading}
                        />
                    ) : (
                        <div className="bg-white border border-[#E4E7EE] rounded-[14px] flex items-center justify-center" style={{minHeight: 720}}>
                            <Spin size="large" className="custom-spin"/>
                        </div>
                    )}
                </div>

                <div
                    className={`${isExpanded ? "lg:col-span-8 " : "lg:col-span-6 "
                    }  col-span-12 `}
                >
                    {(() => {
                        const lockedStatus =
                            selectedItem?.processingStatus === ProcessingStatusEnum.InvoiceCreated ||
                            selectedItem?.processingStatus === ProcessingStatusEnum.Rejected;
                        return lockedStatus ? (
                            <div
                                className="mb-3 rounded-[10px] px-4 py-2.5 flex items-center gap-2 text-[13px]"
                                style={{background: "#F1F3F7", color: "#374152", border: "1px solid #E4E7EE"}}
                            >
                                <LockOutlined style={{color: "#7A849A"}}/>
                                <span>
                                    This invoice is <strong>{selectedItem?.processingStatus}</strong> and is read-only.
                                </span>
                            </div>
                        ) : null;
                    })()}
                    <div
                        ref={attachReadOnlyGuard}
                        className={`overflow-y-auto h-[750px] pr-1 -mr-1 space-y-4 ${
                            selectedItem?.processingStatus === ProcessingStatusEnum.InvoiceCreated ||
                            selectedItem?.processingStatus === ProcessingStatusEnum.Rejected
                                ? "form-readonly"
                                : ""
                        }`}
                        aria-readonly={
                            selectedItem?.processingStatus === ProcessingStatusEnum.InvoiceCreated ||
                            selectedItem?.processingStatus === ProcessingStatusEnum.Rejected
                                ? "true"
                                : undefined
                        }
                    >
                        <div className="border border-[#E4E7EE] rounded-[10px] overflow-hidden mb-4">
                            <div className="px-4 py-3 bg-[#F7F8FB] border-b border-[#E4E7EE]">
                                <div className="grid grid-cols-4 gap-4">
                                    <div className="min-w-0">
                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Source Info</div>
                                        <Tooltip title={selectedItem?.sourceType?.source}>
                                            <div className="text-[13px] text-black truncate">
                                                {selectedItem?.emailValidationQueue?.id ? (
                                                    <button
                                                        className="text-blue-600 hover:underline bg-transparent border-0 p-0 cursor-pointer text-[13px]"
                                                        onClick={() => navigate(`/emailqueues/details/${selectedItem?.emailValidationQueue?.id}`)}
                                                    >
                                                        {selectedItem?.emailValidationQueue?.queueEmail}
                                                    </button>
                                                ) : (
                                                    selectedItem?.sourceType?.source
                                                )}
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <div className="min-w-0">
                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Source Name</div>
                                        <Tooltip title={selectedItem?.updatedBy}>
                                            <div className="text-[13px] text-black truncate">{selectedItem?.updatedBy}</div>
                                        </Tooltip>
                                    </div>
                                    <div className="min-w-0">
                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Date Of Processing</div>
                                        <Tooltip title={formatDate(selectedItem?.createdOn, "dd-MMM-yyyy hh:mm tt")}>
                                            <div className="text-[13px] text-black truncate">{formatDate(selectedItem?.createdOn, "dd-MMM-yyyy hh:mm tt")}</div>
                                        </Tooltip>
                                    </div>
                                    {selectedItem?.emailAddress ? (
                                        <div className="min-w-0">
                                            <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Sender Email</div>
                                            <Tooltip title={selectedItem?.emailAddress}>
                                                <div className="text-[13px] text-black truncate">{selectedItem?.emailAddress}</div>
                                            </Tooltip>
                                        </div>
                                    ) : (
                                        <div />
                                    )}
                                </div>
                                {supplierOutcome?.length > 0 &&
                                    findData("SupplierName") &&
                                    !findSupplierData("SupplierName") &&
                                    supplierOutcome?.toLowerCase !==
                                    findData("SupplierName")?.toLowerCase &&
                                    findData("SupplierName") && (
                                        <div className="mt-2">
                                            <Popover
                                                overlayStyle={{width: "400px"}}
                                                placement="leftBottom"
                                                content={content}
                                                title="Error"
                                                trigger="click"
                                            >
                                                <WarningOutlined
                                                    type="exclamation-circle"
                                                    style={{color: "#A4231D", fontSize: "18px"}}
                                                />
                                            </Popover>
                                        </div>
                                    )}
                            </div>

                            <div className="grid grid-cols-[2fr_1fr] gap-4 p-4">
                                {/* Supplier Name — full width */}
                                <div className="col-span-2">
                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Supplier Name</span><ConfidenceLabel label={"SupplierName"} data={invoiceDetailData}/></div>
                                    <div
                                        className={`${
                                            (supplierOutcome?.length > 0 && supplierOutcome !== findData("SupplierName")) ||
                                            (findData("SupplierName") && findSupplierData("SupplierName"))
                                                ? "w-full border border-yellow-500"
                                                : supplierOutcome?.length > 0 &&
                                                  supplierOutcome?.toLowerCase !== findData("SupplierName")?.toLowerCase &&
                                                  findData("SupplierName")
                                                ? "w-full border border-red-500"
                                                : "w-full border"
                                        }`}
                                    >
                                            <Select
                                                bordered={false}
                                                loading={true}
                                                placeholder="Search Supplier"
                                                showSearch
                                                suffixIcon={
                                                    findData("SupplierName") ? (
                                                        <InfoCircleOutlined
                                                            onClick={handleSupplierPopup}
                                                            className="text-[16px] text-[#1890ff] "
                                                        />
                                                    ) : null
                                                }
                                                notFoundContent={
                                                    supplierLoading ? (
                                                        <Spin className="custom-spin flex justify-center"/>
                                                    ) : (
                                                        supplierOptions &&
                                                        supplierOptions.length <= 0 && (
                                                            <div>
                                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                                            </div>
                                                        )
                                                    )
                                                }
                                                popupMatchSelectWidth={400}
                                                popupmatchselectheight={600}
                                                className="select-width"
                                                id="SupplierName "
                                                value={findData("SupplierName")}
                                                optionLabelProp="label"
                                                open={isSelectOpen}
                                                dropdownStyle={{maxHeight: 600, overflow: "auto"}}
                                                defaultActiveFirstOption={true}
                                                onSearch={handleSupplierSearch}
                                                onSelect={(value, item) => {

                                                    fetchEmailById(item.id, id);
                                                    item.data.Address =
                                                        item.data?.address?.address +
                                                        " " +
                                                        item.data?.address?.town +
                                                        " " +
                                                        item.data?.address?.state +
                                                        " " +
                                                        item.data?.address?.postCode +
                                                        " " +
                                                        "," +
                                                        item.data?.address?.country;
                                                    setSupplierDetails(item.data);
                                                    updateDetailData("SupplierId", item.id);
                                                    updateDetailData("SupplierName", item.label);

                                                    if (item?.data?.isRecoverySupplier && item?.data?.isRecoverySupplier !== isCrewRecovery) {
                                                        updateDetailData("IsCrewRecovery", item?.data?.isRecoverySupplier ? 'True' : 'False');
                                                        setIsCrewRecovery(item?.data?.isRecoverySupplier);
                                                    }

                                                    setBankDetails(item.data.bankDetails);
                                                    setCompanyAllowedCurrencies(
                                                        item.data.companyAllowedCurrencies
                                                    );
                                                    if (
                                                        item.data?.permitInvoiceRounding !== null &&
                                                        item?.permitInvoiceRounding !== undefined
                                                    ) {
                                                        setRoundValues(item.data.permitInvoiceRounding);
                                                    }

                                                    const sortedRecoveryTypes =
                                                        item.data.recoveryServiceTypes.sort();

                                                    const recoverytypess =
                                                        sortedRecoveryTypes &&
                                                        sortedRecoveryTypes.map((item) => ({
                                                            label: item.value, // Set label to the value property
                                                            value: item.id, // Set value to the id property
                                                        }));

                                                    setRecoveryType(recoverytypess);
                                                    setIsSelectOpen(false);
                                                }}
                                            >
                                                <>
                                                    {supplierOptions &&
                                                        supplierOptions.length > 0 &&
                                                        !supplierLoading &&
                                                        supplierOptions.map((item, index) => (
                                                                <Option
                                                                    key={item?.id}
                                                                    value={`${item.name}|${item.id}`}
                                                                    label={item?.name}
                                                                    id={item?.id}
                                                                    data={item}
                                                                >
                                                                    <SupplierOptionCard supplier={item}
                                                                                        isSelected={item.name === findData("SupplierName")}/>
                                                                </Option>
                                                            )
                                                        )}
                                                </>
                                            </Select>
                                        </div>
                                </div>

                                {/* Customer Name */}
                                <div>
                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Customer Name</span><ConfidenceLabel label={"CustomerName"} data={invoiceDetailData}/></div>
                                    <div className={`border w-full hover:border-[#40a9ff] ${vesselMgmtBlocked ? "border-red-500" : vesselMgmtInfo ? "border-yellow-500" : borderColor("CustomerName")}`}>
                                            <Select
                                                bordered={false}
                                                showSearch
                                                notFoundContent={
                                                    customerloading ? (
                                                        <Spin className="custom-spin flex justify-center"/>
                                                    ) : (
                                                        customerOptions &&
                                                        customerOptions.length <= 0 && (
                                                            <div>
                                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                                            </div>
                                                        )
                                                    )
                                                }
                                                suffixIcon={null}
                                                popupMatchSelectWidth={false}
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    (option?.label ?? "")
                                                        .toLowerCase()
                                                        .includes(input.toLowerCase())
                                                }
                                                className="CompanyCustomerName"
                                                options={customerOptions}
                                                id="CustomerName"
                                                value={findData("CustomerName")}
                                                onChange={(value) =>
                                                    updateDetailData("CustomerName", value)
                                                }
                                                onSelect={(value, item) => {
                                                    if (item.VesselId) {
                                                        updateDetailData("VesselId", item.VesselId);
                                                    } else {
                                                        updateDetailData("VesselId", "");
                                                    }
                                                    if (item.VesselName) {
                                                        updateDetailData("VesselName", item.VesselName);
                                                    } else if (!item.vesselName) {
                                                        updateDetailData("VesselName", "");
                                                    }
                                                    updateDetailData("CustomerName", value);
                                                    updateDetailData("CoyId", item.CoyId);
                                                    updateDetailData("CoyName", value);
                                                    setCustomerType(item.AccountingType);
                                                    setIsConsolidatedDetailLines(item?.consolidateDetailLines ?? false);

                                                    updateDetailData(
                                                        "CustomerType",
                                                        item.AccountingType
                                                    );

                                                    lastCheckedCoyIdRef.current = item.id ?? item.CoyId;
                                                    checkVesselManagementStatus({
                                                        customerId: item.id ?? item.CoyId,
                                                        vesselManagementEndDate: item.vesselManagementEndDate,
                                                        vesselResponsibilities: item.vesselResponsibilities,
                                                    });
                                                }}
                                                onSearch={(searchText) => {
                                                    // updateDetailData("CompanyCustomerName ", searchText);
                                                    if (searchText.length > 2) {
                                                        const lowerSearchText = searchText.toLowerCase();
                                                        fetchCustomerOptions(lowerSearchText);
                                                    } else {
                                                        setCustomerOptions([]);
                                                    }
                                                }}
                                            ></Select>
                                    </div>
                                    {vesselMgmtInfo && (() => {
                                        const isBlocked = vesselMgmtBlocked;
                                        const userIsVfc = vesselMgmtInfo.userIsVfc;
                                        const daysLeft = Math.max(0, 60 - vesselMgmtInfo.daysSince);
                                        const tone = isBlocked
                                            ? {text: "text-red-600", linkText: "text-red-700"}
                                            : {text: "text-[#9B6B00]", linkText: "text-[#9B6B00]"};
                                        return (
                                            <div className={`mt-1.5 flex items-start gap-1.5 text-[12px] leading-snug ${tone.text}`}>
                                                <WarningOutlined className="mt-[2px] flex-shrink-0"/>
                                                <span>
                                                    Vessel left management on{" "}
                                                    <strong>{vesselMgmtInfo.endDate.format("DD-MMM-YYYY")}</strong>{" "}
                                                    ({vesselMgmtInfo.daysSince} day{vesselMgmtInfo.daysSince === 1 ? "" : "s"} ago).{" "}
                                                    {userIsVfc ? (
                                                        <>
                                                            You are the <strong>{VFC_RESPONSIBILITY_NAME}</strong> for this vessel — submission is allowed.
                                                        </>
                                                    ) : isBlocked ? (
                                                        <>
                                                            <strong>Submission blocked</strong> (60-day window has passed)
                                                            {vesselMgmtInfo.primaryContact?.user?.email ? (
                                                                <>
                                                                    {" "}— contact{" "}
                                                                    <a
                                                                        href={`mailto:${vesselMgmtInfo.primaryContact.user.email}`}
                                                                        className={`underline ${tone.linkText}`}
                                                                    >
                                                                        {vesselMgmtInfo.primaryContact.user.name || vesselMgmtInfo.primaryContact.user.email}
                                                                    </a>
                                                                </>
                                                            ) : (
                                                                <> — contact the assigned VFC for this vessel.</>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            Submission allowed for{" "}
                                                            <strong>{daysLeft} more day{daysLeft === 1 ? "" : "s"}</strong>.
                                                            After that you'll need to contact{" "}
                                                            {vesselMgmtInfo.primaryContact?.user?.email ? (
                                                                <a
                                                                    href={`mailto:${vesselMgmtInfo.primaryContact.user.email}`}
                                                                    className={`underline ${tone.linkText}`}
                                                                >
                                                                    {vesselMgmtInfo.primaryContact.user.name || vesselMgmtInfo.primaryContact.user.email}
                                                                </a>
                                                            ) : (
                                                                <>the assigned VFC for this vessel</>
                                                            )}.
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        );
                                    })()}
                                </div>

                                {/* COY ID */}
                                <div>
                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>COY ID</span><ConfidenceLabel label={"CoyId"} data={invoiceDetailData}/></div>
                                    <div className="flex">
                                        <Input
                                            readOnly
                                            disabled={true}
                                            id="CoyId"
                                            className="h-10"
                                            value={findData("CoyId")}
                                        />
                                    </div>
                                </div>

                                {/* Invoice Type */}
                                <div>
                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Invoice Type</div>
                                    <Select
                                        defaultValue="Invoice"
                                        value={findData("InvoiceDocumentClassificationId")}
                                        className="w-full"
                                        options={DocumentTypeOptions}
                                        size="middle"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                        onSelect={(data) => updateDetailData("InvoiceDocumentClassificationId", data)}
                                    />
                                </div>

                                {/* Vessel Name — conditional */}
                                {(customerType === "vessel" || findData("CustomerType")?.toLowerCase() === "vessel") && (
                                    <div>
                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Vessel Name</span><ConfidenceLabel label={"VesselName"} data={invoiceDetailData}/></div>
                                        <div className="flex">
                                            <Input
                                                id="VesselName"
                                                className={`h-10 ${borderColor("VesselName")}`}
                                                value={customerType === "entity" ? "" : findData("VesselName")}
                                                onChange={(e, i) => handleInputChange(e, i)}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Toggle switches */}
                            <div className="flex flex-wrap gap-x-6 gap-y-3 px-4 pb-4 pt-3 border-t border-gray-100">
                                {convertToBoolean(REACT_APP_SETTINGS_SHOW_MASTER_AND_OWNERS) && (
                                    <div className="flex items-center gap-2">
                                        <Switch
                                            size="small"
                                            style={{
                                                backgroundColor: isMasterAndOwners ? "#1B7A31" : isMasterAndOwnersDisabled ? "#7A849A" : "#A4231D",
                                            }}
                                            id="IsMasterAndOwners"
                                            onChange={(value) =>
                                                updateDetailData(
                                                    "IsMasterAndOwners",
                                                    value === true ? "True" : "False"
                                                )
                                            }
                                            checked={isMasterAndOwners}
                                            disabled={isMasterAndOwnersDisabled}
                                        />
                                        <span className="text-sm text-gray-700">Masters And Owners</span>
                                    </div>
                                )}
                                {convertToBoolean(REACT_APP_SETTINGS_SHOW_MULTI_COMPANY) && (
                                    <div className="flex items-center gap-2">
                                        <Switch
                                            size="small"
                                            style={{backgroundColor: isMultiCompany ? "#1B7A31" : "#7A849A"}}
                                            id="IsMultiCompany"
                                            onChange={(value) => {
                                                updateDetailData(
                                                    "IsMultiCompany",
                                                    value === true ? "True" : "False"
                                                )
                                            }}
                                            checked={isMultiCompany}
                                        />
                                        <span className="text-sm text-gray-700">Multi Company Invoice</span>
                                    </div>
                                )}
                                {convertToBoolean(REACT_APP_SETTINGS_SHOW_SEAFARER_INVOICE) && (
                                    <div className="flex items-center gap-2">
                                        <Switch
                                            size="small"
                                            style={{
                                                backgroundColor: isCrewRecovery
                                                    ? "#1B7A31"
                                                    : "#7A849A",
                                            }}
                                            id="IsCrewRecovery"
                                            checked={isCrewRecovery}
                                            onChange={(value) => {
                                                if (value === false) {
                                                    handleDeleteRecoveryItem(value, 0)
                                                }
                                                updateDetailData(
                                                    "IsCrewRecovery",
                                                    value === true ? "True" : "False"
                                                )
                                                setIsCrewRecovery(value);
                                            }}
                                        />
                                        <span className="text-sm text-gray-700">Seafarer Invoice</span>
                                    </div>
                                )}
                                <div className="flex items-center gap-2">
                                    <Switch
                                        size="small"
                                        id="ContainsDeliveryNote"
                                        className="ContainsDeliveryNote"
                                        style={{
                                            backgroundColor: isChecked
                                                ? "#1B7A31"
                                                : "#7A849A",
                                        }}
                                        checked={
                                            findData("ContainsDeliveryNote") || isChecked
                                        }
                                        onChange={(checked) => {
                                            setChecked(checked);
                                            updateDetailData("ContainsDeliveryNote", checked);
                                        }}
                                    />
                                    <span className="text-sm text-gray-700">Contains Delivery Note</span>
                                </div>
                            </div>
                        </div>

                        {isCrewRecovery && (
                            <div className="mt-3">
                                <Collapse className="collapse-style">
                                    <Panel
                                        header={
                                            <div className="flex items-center gap-2">
                                                <span className="text-black text-[15px] font-normal">Crew Recovery</span>
                                                <span className="text-[#7A849A] text-[13px]">· {recoveryData?.length ?? 0}</span>
                                            </div>
                                        }
                                        extra={
                                            <Tooltip title="Add recovery">
                                                <Button
                                                    type="text"
                                                    size="small"
                                                    icon={<PlusOutlined/>}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAddRecovery();
                                                    }}
                                                >
                                                    Add
                                                </Button>
                                            </Tooltip>
                                        }
                                    >
                                        <div className="flex flex-col gap-3 p-2">
                                            {recoveryData && recoveryData.length > 0 && (
                                                <div
                                                    className="grid items-center px-3 py-1.5 rounded-md text-[12px] font-semibold text-[#374152]"
                                                    style={{gridTemplateColumns: "90px 1fr 1fr 30px", gap: 8, background: "#e8eaed"}}
                                                >
                                                    <div/>
                                                    <div>Invoice <span className="text-[#7A849A] font-normal">(OCR)</span></div>
                                                    <div>Shipsure Validated</div>
                                                    <div/>
                                                </div>
                                            )}

                                            {recoveryData && recoveryData.length > 0 ? (
                                                recoveryData.map((recoveryItem, index) => {
                                                    const PcnIsMismatch = (() => {
                                                        const s = getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryPCN");
                                                        const v = getInvoiceRecoveryValue(recoveryItem, "RecoveryPCN");
                                                        if (!s || !v) return null;
                                                        return s !== v;
                                                    })();

                                                    const VesselIsMismatch = (() => {
                                                        const s = getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryVesselName");
                                                        const v = getInvoiceRecoveryValue(recoveryItem, "RecoveryVesselName");
                                                        if (!s || !v) return null;
                                                        return s !== v;
                                                    })();

                                                    const SeafarerIsMismatch = (() => {
                                                        const sRaw = getShipsureValidatedCorrectedValue(recoveryItem, "RecoverySeafarerName");
                                                        const vRaw = getInvoiceRecoveryValue(recoveryItem, "RecoverySeafarerName");
                                                        const s = sRaw ? sRaw.trim().replace(/\s+/g, "") : "";
                                                        const v = vRaw ? vRaw.trim().replace(/\s+/g, "") : "";
                                                        if (!s || !v) return null;
                                                        return s !== v;
                                                    })();

                                                    const oneTimeChecked =
                                                        getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryOneTime") === "True" ||
                                                        getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryOneTime") === true;

                                                    const fiValue =
                                                        getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryFI") || null;

                                                    const fieldRowStyle = {
                                                        gridTemplateColumns: "90px 1fr 1fr 30px",
                                                        gap: 8,
                                                    };

                                                    return (
                                                        <div key={index} className="border border-[#E4E7EE] rounded-[10px] overflow-hidden">
                                                            {/* Recovery Type + Delete — card header */}
                                                            <div
                                                                className="grid items-center px-3 py-2 border-b border-[#E4E7EE]"
                                                                style={{gridTemplateColumns: "90px 1fr 30px", gap: 8, background: "#e1e3e6"}}
                                                            >
                                                                <div className="font-medium text-[#0B1220] text-[13px]">Recovery type</div>
                                                                <Select
                                                                    className="select-width w-full"
                                                                    placeholder="Select Recovery Type"
                                                                    options={recoveryType}
                                                                    popupMatchSelectWidth={300}
                                                                    onSelect={(value, item) => {
                                                                        handleSelectRecoveryTypeChange(value, item, index);
                                                                    }}
                                                                    size="middle"
                                                                    value={handleRecoveryValue(index)}
                                                                />
                                                                <Tooltip title="Remove">
                                                                    <Button
                                                                        size="small"
                                                                        type="text"
                                                                        danger
                                                                        icon={<DeleteOutlined/>}
                                                                        onClick={(e) => handleDeleteRecoveryItem(e, index)}
                                                                    />
                                                                </Tooltip>
                                                            </div>

                                                            {/* PCN */}
                                                            <div className="grid items-center px-3 py-2" style={fieldRowStyle}>
                                                                <div className="cell-sub">PCN</div>
                                                                <Input
                                                                    id="RecoveryPCN"
                                                                    disabled={true}
                                                                    value={getInvoiceRecoveryValue(recoveryItem, "RecoveryPCN")}
                                                                    readOnly
                                                                    suffix={<LockOutlined style={{color: "gray"}}/>}
                                                                />
                                                                <Input
                                                                    id="RecoveryPCN"
                                                                    value={getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryPCN")}
                                                                    onChange={(e) => handleInputRecoveryChangeData(e, index)}
                                                                />
                                                                <MismatchIndicator isMismatch={PcnIsMismatch}/>
                                                            </div>

                                                            {/* Vessel */}
                                                            <div className="grid items-center px-3 py-2" style={fieldRowStyle}>
                                                                <div className="cell-sub">Vessel</div>
                                                                <Input
                                                                    id="RecoveryVesselName"
                                                                    disabled={true}
                                                                    value={getInvoiceRecoveryValue(recoveryItem, "RecoveryVesselName")}
                                                                    readOnly
                                                                    suffix={<LockOutlined style={{color: "gray"}}/>}
                                                                />
                                                                <Select
                                                                    placeholder="Search"
                                                                    showSearch
                                                                    notFoundContent={
                                                                        vesselloading ? (
                                                                            <Spin className="custom-spin flex justify-center"/>
                                                                        ) : (
                                                                            recoveryVessel && recoveryVessel.length <= 0 && (
                                                                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                                                            )
                                                                        )
                                                                    }
                                                                    suffixIcon={null}
                                                                    popupMatchSelectWidth={false}
                                                                    className={`w-full ${recoveryItem?.RecoveryVesselName?.className}`}
                                                                    options={recoveryVessel}
                                                                    id="RecoveryVesselName"
                                                                    value={getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryVesselName")}
                                                                    onSelect={(value, item) => {
                                                                        handleInputRecoveryChange("RecoveryVesselName", value, index);
                                                                        if (item?.vesselId)
                                                                            handleInputRecoveryChange("RecoveryVesselId", item.vesselId, index);
                                                                    }}
                                                                    onSearch={(searchText) => {
                                                                        if (searchText.length > 2) {
                                                                            fetchRecoveryVesselOptions(searchText);
                                                                        }
                                                                    }}
                                                                />
                                                                <MismatchIndicator isMismatch={VesselIsMismatch}/>
                                                            </div>

                                                            {/* Seafarer */}
                                                            <div className="grid items-center px-3 py-2" style={fieldRowStyle}>
                                                                <div className="cell-sub">Seafarer</div>
                                                                <Input
                                                                    id="RecoverySeafarerName"
                                                                    disabled={true}
                                                                    value={getInvoiceRecoveryValue(recoveryItem, "RecoverySeafarerName")}
                                                                    readOnly
                                                                    suffix={<LockOutlined style={{color: "gray"}}/>}
                                                                />
                                                                <Input
                                                                    id="RecoverySeafarerName"
                                                                    placeholder="Search for Seafarer"
                                                                    value={getShipsureValidatedCorrectedValue(recoveryItem, "RecoverySeafarerName")}
                                                                    onChange={(e) => handleInputRecoveryChangeData(e, index)}
                                                                    suffix={
                                                                        <SearchOutlined
                                                                            className="cursor-pointer text-[var(--primary-color)]"
                                                                            onClick={() => handleRecoveryPopup(index)}
                                                                        />
                                                                    }
                                                                />
                                                                <MismatchIndicator isMismatch={SeafarerIsMismatch}/>
                                                            </div>

                                                            {/* Footer: Amount + FI + One-time */}
                                                            <div
                                                                className="grid items-center px-3 py-2 border-t border-[#E4E7EE]"
                                                                style={{...fieldRowStyle, background: "#F7F8FB"}}
                                                            >
                                                                <div className="cell-sub">Amount · FI</div>
                                                                <div className="flex items-center gap-2">
                                                                    <Input
                                                                        type="number"
                                                                        id="RecoveryAmount"
                                                                        placeholder="0.00"
                                                                        step={0.01}
                                                                        value={convertStringToFloat(getShipsureValidatedCorrectedValue(recoveryItem, "RecoveryAmount"))}
                                                                        onChange={(e) => handleInputRecoveryChangeData(e, index)}
                                                                        style={{flex: 1}}
                                                                    />
                                                                    <Select
                                                                        placeholder="FI/NFI"
                                                                        value={fiValue}
                                                                        options={[
                                                                            {label: "Fixed", value: "Fixed"},
                                                                            {label: "Non-Fixed", value: "Non-Fixed"},
                                                                        ]}
                                                                        onChange={(value) => {
                                                                            handleInputRecoveryChange("RecoveryFI", value, index);
                                                                        }}
                                                                        allowClear
                                                                        style={{width: 120}}
                                                                    />
                                                                </div>
                                                                <Tooltip title="Check option if you wish the Recovery to be processed once only.">
                                                                    <label className="inline-flex items-center gap-2 text-[12px] text-[#374152] cursor-pointer">
                                                                        <Switch
                                                                            id="RecoveryOneTime"
                                                                            size="small"
                                                                            onClick={(checked) => {
                                                                                handleInputRecoveryChange("RecoveryOneTime", checked, index);
                                                                            }}
                                                                            checked={oneTimeChecked}
                                                                            defaultChecked={false}
                                                                            style={{
                                                                                backgroundColor: oneTimeChecked ? "#1B7A31" : "#7A849A",
                                                                            }}
                                                                        />
                                                                        One-time
                                                                    </label>
                                                                </Tooltip>
                                                                <div/>
                                                            </div>

                                                            {crewRecoveryPopup && (
                                                                <CrewRecoveryPopup
                                                                    recoveryIndexPopup={recoveryIndexPopup}
                                                                    visible={crewRecoveryPopup}
                                                                    recoveryData={recoveryData}
                                                                    setCrewRecoveryPopup={setCrewRecoveryPopup}
                                                                    onClose={handleCrewRecoveryPopupClosed}
                                                                    OnAddButtonClick={handleAddRecoveryFromPopup}
                                                                />
                                                            )}
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="py-8 text-center text-[#7A849A] text-[13px] italic">
                                                    No recovery items. Click <strong>Add</strong> to create one.
                                                </div>
                                            )}
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>
                        )}

                        <div className="mt-3">
                            <Collapse className="collapse-style" defaultActiveKey={["1"]}>
                                <Panel
                                    header={
                                        <div className="flex items-center justify-between">
                                            <span className="text-black text-[15px] font-normal">Invoice Header</span>
                                            {purchaseOrderList && purchaseOrderList.length > 1 && (
                                                <Popover
                                                    placement="leftBottom"
                                                    title="Error"
                                                    onClick={handlePopupClick}
                                                    trigger="click"
                                                    content={headercontent}
                                                >
                                                    <WarningOutlined
                                                        type="exclamation-circle"
                                                        style={{color: "#A4231D", fontSize: "18px"}}
                                                    />
                                                </Popover>
                                            )}
                                        </div>
                                    }
                                    >
                                        <div className="pt-2">
                                            {/* Invoice fields — 2-column grid */}
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Invoice No</span><ConfidenceLabel label={"InvoiceId"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            id="InvoiceId"
                                                            className={`h-10 border ${borderColor("InvoiceId")}`}
                                                            value={findData("InvoiceId")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">PO Reference</div>
                                                    <div className="flex">
                                                        <Input
                                                            id="PurchaseOrder"
                                                            placeholder="00000"
                                                            className={`purchase-width h-10 border ${borderColor("PurchaseOrder")}`}
                                                            value={findData("PurchaseOrder")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                            suffix={
                                                                <FileTextOutlined
                                                                    className="text-[var(--secondary-color)]"
                                                                    onClick={handleImageClick}
                                                                />
                                                            }
                                                        />
                                                        {popupVisible && (
                                                            <PurchasePopup
                                                                invoiceDetailData={invoiceDetailData}
                                                                visible={popupVisible}
                                                                onClose={handlePopupClosed}
                                                                onAddClick={handleAddButtonClick}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Payment Term</span><ConfidenceLabel label={"PaymentTermDays"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <div className="w-full flex items-center">
                                                            <Input
                                                                id="PaymentTermDays"
                                                                className={`h-10 border ${borderColor("PaymentTermDays")}`}
                                                                value={findData("PaymentTermDays")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                            <div className="pl-2 whitespace-nowrap">Days</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Purchase Order</div>
                                                    <div className="flex">
                                                        <Input
                                                            id="PurchaseOrderNumber"
                                                            placeholder="00000"
                                                            className={`purchase-width h-10 border ${borderColor("PurchaseOrderNumber")}`}
                                                            value={findData("PurchaseOrderNumber")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                            suffix={
                                                                poValidation && findData("PurchaseOrderNumber") !== "" ? (
                                                                    <CheckCircleOutlined className="text-[#16a34a] cursor-pointer h-full w-full text-[18px] rounded-full" />
                                                                ) : poValidation === false && findData("PurchaseOrderNumber") !== "" ? (
                                                                    <CloseCircleOutlined className="text-[#FF6F61] h-full text-[22px] w-full rounded-full" />
                                                                ) : null
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Invoice Date</span><ConfidenceLabel label={"InvoiceDate"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <DatePicker
                                                            id="InvoiceDate"
                                                            className={`h-10 w-full border ${borderColor("InvoiceDate")}`}
                                                            value={findData("InvoiceDate") ? parseDate(findData("InvoiceDate")) : null}
                                                            onChange={handleInvoiceDateChange}
                                                            format={"DD/MM/YYYY"}
                                                            allowClear={false}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Due Date</span><ConfidenceLabel label={"DueDate"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <div className="w-full flex items-center">
                                                            <DatePicker
                                                                id="DueDate"
                                                                className={`h-10 w-full border ${borderColor("DueDate")}`}
                                                                value={findData("DueDate") ? parseDate(findData("DueDate")) : null}
                                                                onChange={handleDueDateChange}
                                                                format="DD/MM/YYYY"
                                                                allowClear={false}
                                                            />
                                                            {findData("InvoiceDueDateMethod") && (
                                                                <div style={{marginLeft: "8px"}}>
                                                                    <Popover
                                                                        content={DueDatecontent}
                                                                        title={<div className="text-[14px]">DueDate Method</div>}
                                                                        trigger="hover"
                                                                    >
                                                                        <InfoCircleOutlined style={{fontSize: "16px", color: "#1890ff"}} />
                                                                    </Popover>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {(() => {
                                                const supplierCountry = supplierDetails?.address?.country;
                                                const supplierCountryCode =
                                                    supplierCountry?.isoA3 ?? supplierCountry ?? "";
                                                if (customerCountryCode !== "PHL" || supplierCountryCode !== "PHL") {
                                                    return null;
                                                }
                                                return (
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Net Value</span><ConfidenceLabel label={"FNNetValue"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            type="number"
                                                            id="FNNetValue"
                                                            placeholder="0.00"
                                                            step={0.01}
                                                            className={`h-10 border text-right ${borderColor("FNNetValue")}`}
                                                            value={findData("FNNetValue")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Finance Tax Code</span><ConfidenceLabel label={"FNTaxCodeId"} data={invoiceDetailData}/></div>
                                                    <div className={`flex rounded ${borderColor("FNTaxCodeId") === "border-yellow-500" ? "border-yellow-500" : "border-[#CFD4DF]"}`}>
                                                        <Select
                                                            id="FNTaxCodeId"
                                                            placeholder="Select tax code"
                                                            className="w-full"
                                                            bordered={false}
                                                            value={findData("FNTaxCodeId") || undefined}
                                                            showSearch
                                                            allowClear
                                                            optionFilterProp="label"
                                                            filterOption={(input, option) => {
                                                                const label = typeof option?.label === "string" ? option.label : "";
                                                                return label.toLowerCase().includes(input.toLowerCase());
                                                            }}
                                                            onChange={(value) => updateDetailData("FNTaxCodeId", value ?? "")}
                                                        >
                                                            {financeTaxCodeTypes.map((type) => (
                                                                <OptGroup
                                                                    key={type.id}
                                                                    label={
                                                                        <span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">
                                                                            {type.name}
                                                                        </span>
                                                                    }
                                                                >
                                                                    {(type.taxCodes ?? []).map((tc) => (
                                                                        <Option
                                                                            key={tc.id}
                                                                            value={tc.id}
                                                                            label={`${tc.name} · ${tc.code}${tc.guidelinesCriteria ? ` · ${tc.guidelinesCriteria}` : ""}`}
                                                                        >
                                                                            <div className="py-1">
                                                                                <div className="flex items-center justify-between gap-3">
                                                                                    <span className="text-[13px] font-medium text-[#0B1220] truncate">{tc.name}</span>
                                                                                    <span className="cell-mono text-[11.5px] text-[#7A849A] flex-shrink-0">
                                                                                        {tc.code}{tc.country?.isoA3 ? ` · ${tc.country.isoA3}` : ""}
                                                                                    </span>
                                                                                </div>
                                                                                {tc.guidelinesCriteria && (
                                                                                    <div className="text-[11.5px] text-[#7A849A] truncate mt-0.5">
                                                                                        {tc.guidelinesCriteria}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </Option>
                                                                    ))}
                                                                </OptGroup>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                </div>
                                            </div>
                                                );
                                            })()}

                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Department</span><ConfidenceLabel label={"DepartmentId"} data={invoiceDetailData}/></div>
                                                    <div className={`flex rounded ${borderColor("DepartmentId") === "border-yellow-500" ? "border-yellow-500" : "border-[#CFD4DF]"}`}>
                                                        <Select
                                                            id="DepartmentId"
                                                            placeholder="Select department"
                                                            className="w-full"
                                                            bordered={false}
                                                            value={findData("DepartmentId") || undefined}
                                                            options={departmentOptions}
                                                            showSearch
                                                            allowClear
                                                            optionFilterProp="label"
                                                            filterOption={(input, option) =>
                                                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                                            }
                                                            onChange={(value) => updateDetailData("DepartmentId", value ?? "")}
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Is Proforma Invoice</span><ConfidenceLabel label={"IsProformaInvoice"} data={invoiceDetailData}/></div>
                                                    <div className="flex items-center h-10 gap-2">
                                                        <Switch
                                                            size="small"
                                                            id="IsProformaInvoice"
                                                            checked={convertToBoolean(findData("IsProformaInvoice"))}
                                                            onChange={(value) =>
                                                                updateDetailData(
                                                                    "IsProformaInvoice",
                                                                    value === true ? "True" : "False"
                                                                )
                                                            }
                                                            style={{
                                                                backgroundColor: convertToBoolean(findData("IsProformaInvoice")) ? "#1B7A31" : "#7A849A",
                                                            }}
                                                        />
                                                        <span className="text-sm text-[#374152]">
                                                            {convertToBoolean(findData("IsProformaInvoice")) ? "Yes" : "No"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 gap-4 mt-4">
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Description</span><ConfidenceLabel label={"InvoiceHeaderDescription"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <TextArea
                                                            id="InvoiceHeaderDescription"
                                                            placeholder="Add a description"
                                                            autoSize={{minRows: 2, maxRows: 6}}
                                                            className={`border ${borderColor("InvoiceHeaderDescription")}`}
                                                            value={findData("InvoiceHeaderDescription")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Address sections — 2×2 grid */}
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
                                                <div className="border rounded-md p-3">
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-3">Supplier Address</div>
                                                    <div className="mb-3">
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Recipient</span><ConfidenceLabel label={"VendorAddressRecipient"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                disabled={true}
                                                                readOnly
                                                                id="VendorAddressRecipient"
                                                                className=""
                                                                value={findData("VendorAddressRecipient")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Address</span><ConfidenceLabel label={"VendorAddress"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                disabled={true}
                                                                readOnly
                                                                id="VendorAddress"
                                                                className=""
                                                                value={findData("VendorAddress")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="border rounded-md p-3">
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-3">Customer Address</div>
                                                    <div className="mb-3">
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Recipient</span><ConfidenceLabel label={"CustomerAddressRecipient"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                id="CustomerAddressRecipient"
                                                                className={`border ${borderColor("CustomerAddressRecipient")}`}
                                                                value={findData("CustomerAddressRecipient")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Address</span><ConfidenceLabel label={"CustomerAddress"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                id="CustomerAddress"
                                                                className={`border ${borderColor("CustomerAddress")}`}
                                                                value={findData("CustomerAddress")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="border rounded-md p-3">
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-3">Billing Address</div>
                                                    <div className="mb-3">
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Recipient</span><ConfidenceLabel label={"BillingAddressRecipient"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                id="BillingAddressRecipient"
                                                                className={`border ${borderColor("BillingAddressRecipient")}`}
                                                                value={findData("BillingAddressRecipient")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Address</span><ConfidenceLabel label={"BillingAddress"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                id="BillingAddress"
                                                                className={`border ${borderColor("BillingAddress")}`}
                                                                value={findData("BillingAddress")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="border rounded-md p-3">
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-3">Shipping Address</div>
                                                    <div className="mb-3">
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Recipient</span><ConfidenceLabel label={"ShippingAddressRecipient"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                id="ShippingAddressRecipient"
                                                                className={`border ${borderColor("ShippingAddressRecipient")}`}
                                                                value={findData("ShippingAddressRecipient")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Address</span><ConfidenceLabel label={"ShippingAddress"} data={invoiceDetailData}/></div>
                                                        <div className="flex">
                                                            <TextArea
                                                                id="ShippingAddress"
                                                                className={`border ${borderColor("ShippingAddress")}`}
                                                                value={findData("ShippingAddress")}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                </Panel>
                            </Collapse>
                        </div>
                        {!isCrewRecovery && (
                            <div className="mt-3">
                                <Collapse className="collapse-style">
                                    <Panel
                                        header={
                                            <div className="flex items-center justify-between">
                                                <span className="text-black text-[15px] font-normal">Invoice Details</span>
                                                {!isConsolidatedDetailLines && (
                                                        <div>
                                                            {(hasDescriptionWithTaxRef.current &&
                                                                hasTaxValueCheckRef.current > 0 &&
                                                                findData("TotalTax") > 0) ||
                                                            (invalidDescriptions &&
                                                                invalidDescriptions.length > 0) ||
                                                            (hasDescriptionWithTaxRef.current &&
                                                                hasTaxValueCheckRef.current === findData("TotalTax")) ? (
                                                                <div>
                                                                    <Popover
                                                                        placement="leftBottom"
                                                                        onClick={handlePopupClick}
                                                                        content={
                                                                            <>
                                                                                <div>
                                                                                    <div>
                                                                                        {hasDescriptionWithTaxRef.current &&
                                                                                            hasTaxValueCheckRef.current &&
                                                                                            findData("TotalTax") &&
                                                                                            hasTaxValueCheckRef.current ===
                                                                                            findData("TotalTax") && (
                                                                                                <div>
                                                                                                    Value
                                                                                                    of <b>Tax</b> in
                                                                                                    both{" "}
                                                                                                    <b>Invoice
                                                                                                        details</b> and{" "}
                                                                                                    <b>Invoice
                                                                                                        Summary</b> is
                                                                                                    same
                                                                                                </div>
                                                                                            )}
                                                                                    </div>
                                                                                    <div>
                                                                                        {hasDescriptionWithTaxRef.current &&
                                                                                            hasTaxValueCheckRef.current > 0 &&
                                                                                            findData("TotalTax") > 0 && (
                                                                                                <div>
                                                                                                    Duplicate entry
                                                                                                    of <b>Tax</b> is
                                                                                                    found in <b>Invoice
                                                                                                    Details</b>.{" "}
                                                                                                </div>
                                                                                            )}
                                                                                    </div>
                                                                                    <div>
                                                                                        {invalidDescriptions &&
                                                                                            invalidDescriptions.length > 0 &&
                                                                                            invalidDescriptions.map(
                                                                                                (description, index) => (
                                                                                                    <p key={index}>
                                                                                                        The{" "}
                                                                                                        <span
                                                                                                            className="font-bold">
                                                      {description}
                                                    </span>{" "}
                                                                                                        <span
                                                                                                            className="font-bold">
                                                      Total
                                                    </span>{" "}
                                                                                                        is Incorrect
                                                                                                    </p>
                                                                                                )
                                                                                            )}
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        title="Error"
                                                                        trigger="click"
                                                                    >
                                                                        <WarningOutlined
                                                                            type="exclamation-circle"
                                                                            style={{color: "#A4231D", fontSize: "18px"}}
                                                                        />
                                                                    </Popover>
                                                                </div>
                                                            ) : (
                                                                <div></div>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>
                                            }
                                        >
                                            {!isConsolidatedDetailLines ? (
                                                <>
                                                    {/* Column headers */}
                                                    <div className="grid grid-cols-[3fr_1fr_1fr_1fr_32px] h-8 bg-[#e8eaed] rounded-md items-center text-[12px] font-semibold text-[#374152] px-2">
                                                        <div className="text-center">Description</div>
                                                        <div className="text-center">Qty</div>
                                                        <div className="text-center">Unit Price</div>
                                                        <div className="text-center">Total</div>
                                                        <div
                                                            className="flex justify-center cursor-pointer"
                                                            onClick={(index) => handleAddInput(index)}
                                                        >
                                                            <PlusOutlined/>
                                                        </div>
                                                    </div>
                                                    {invoiceGetData && invoiceGetData?.length > 0 ? (
                                                        invoiceGetData
                                                            .filter((item) => item !== undefined && item !== "IBAN" && item !== "SWIFT")
                                                            .map((item, index) => (
                                                                <div key={index} className="grid grid-cols-[3fr_1fr_1fr_1fr_32px] py-1 items-center border-b border-gray-100 last:border-0 line-item-row">
                                                                    <div className="flex pr-1 relative">
                                                                        <ConfidenceLabel
                                                                            label={"Description"}
                                                                            data={item?.Description}
                                                                            index={index}
                                                                        />
                                                                        <Input
                                                                            id="Description"
                                                                            autoComplete="off"
                                                                            className={`h-10 border ${item?.Description?.className}`}
                                                                            onChange={(e) => {
                                                                                e.preventDefault();
                                                                                handleInputDetailChange(e, index);
                                                                            }}
                                                                            value={getDescriptionItem(item, "Description")}
                                                                        />
                                                                    </div>
                                                                    <div className="flex px-1 relative">
                                                                        <ConfidenceLabel
                                                                            label={"Quantity"}
                                                                            data={item?.Quantity}
                                                                            index={index}
                                                                        />
                                                                        <Input
                                                                            id="Quantity"
                                                                            type="number"
                                                                            className={`h-10 border text-center no-spinners ${item?.Quantity?.className}`}
                                                                            value={getDescriptionItem(item, "Quantity")}
                                                                            onChange={(e) => handleInputDetailChange(e, index)}
                                                                        />
                                                                    </div>
                                                                    <div className="flex px-1 relative">
                                                                        <ConfidenceLabel
                                                                            label={"UnitPrice"}
                                                                            data={item?.UnitPrice}
                                                                            index={index}
                                                                        />
                                                                        <Input
                                                                            id="UnitPrice"
                                                                            type="number"
                                                                            className={`h-10 border text-end no-spinners ${item?.UnitPrice?.className}`}
                                                                            value={removeAlphabetsFromString(getDescriptionItem(item, "UnitPrice"))}
                                                                            onChange={(e) => handleInputDetailChange(e, index)}
                                                                        />
                                                                    </div>
                                                                    <div className={`flex px-1 relative ${
                                                                        (!getDescriptionItem(item, "Quantity") && !getDescriptionItem(item, "UnitPrice")) ||
                                                                        (!getDescriptionItem(item, "Quantity") && parseFloat(removeAlphabetsFromString(getDescriptionItem(item, "UnitPrice"))) === parseFloat(removeAlphabetsFromString(getDescriptionItem(item, "Amount")))) ||
                                                                        parseFloat(removeAlphabetsFromString(getDescriptionItem(item, "Amount"))) === parseFloat((parseFloat(removeAlphabetsFromString(getDescriptionItem(item, "UnitPrice"))) * parseFloat(getDescriptionItem(item, "Quantity"))).toFixed(2))
                                                                            ? ""
                                                                            : "border border-red-800"
                                                                    }`}>
                                                                        <ConfidenceLabel
                                                                            label={"Amount"}
                                                                            data={item?.Amount}
                                                                            index={index}
                                                                        />
                                                                        <Input
                                                                            id="Amount"
                                                                            type="number"
                                                                            className={`h-10 border text-end no-spinners ${item?.Amount?.className}`}
                                                                            value={removeAlphabetsFromString(getDescriptionItem(item, "Amount"))}
                                                                            onChange={(e) => handleInputDetailChange(e, index)}
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        className="flex justify-center items-center cursor-pointer"
                                                                        onClick={(e) => handleDeleteInput(e, index)}
                                                                    >
                                                                        <DeleteOutlined/>
                                                                    </div>
                                                                </div>
                                                            ))
                                                    ) : (
                                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {/* Consolidated column headers */}
                                                    <div className="grid grid-cols-[3fr_1fr] h-8 bg-[#e8eaed] rounded-md items-center text-[12px] font-semibold text-[#374152] px-2">
                                                        <div className="text-center">Description</div>
                                                        <div className="text-center">Total</div>
                                                    </div>
                                                    <div className="py-1">
                                                        <p style={{color: "gray"}}>
                                                            <strong><i>{`Entity '${findData("CoyId") ?? "undefined"} - ${findData("CustomerName")}' is setup for consolidated line items.`}</i></strong>
                                                        </p>
                                                    </div>
                                                    <div className="grid grid-cols-[3fr_1fr] py-1 items-center line-item-row">
                                                        <div className="flex pr-1 relative">
                                                            <ConfidenceLabel
                                                                label={"InvoiceDescription"}
                                                                data={invoiceDetailData}
                                                            />
                                                            <Input
                                                                id="InvoiceDescription"
                                                                autoComplete="off"
                                                                placeholder="Please add an Invoice Description"
                                                                onChange={(e, i) => {
                                                                    e.preventDefault();
                                                                    handleInputChange(e, i);
                                                                }}
                                                                value={findData("InvoiceDescription")}
                                                            />
                                                        </div>
                                                        <div className="flex pl-1 relative">
                                                            <ConfidenceLabel
                                                                label={"SubTotal"}
                                                                data={invoiceDetailData}
                                                            />
                                                            <Input
                                                                id="SubTotal"
                                                                readOnly={true}
                                                                disabled={true}
                                                                value={parseFloat(removeAlphabetsFromString(findData("SubTotal")))}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                    </Panel>
                                </Collapse>
                            </div>
                        )}

                        <div className="mt-3">
                            <Collapse className="collapse-style">
                                <Panel
                                    header={
                                        <div className="flex items-center justify-between">
                                            <span className="text-black text-[15px] font-normal">Invoice Summary</span>
                                                {((!isConsolidatedDetailLines && !isCrewRecovery &&
                                                        amountSum &&
                                                        amountSum !==
                                                        parseFloat(
                                                            removeAlphabetsFromString(findData("SubTotal"))
                                                        )) ||
                                                    (total &&
                                                        findData("InvoiceTotal") &&
                                                        !roundValues &&
                                                        roundToDecimalPlaces(total, 2) !==
                                                        parseFloat(
                                                            removeAlphabetsFromString(
                                                                findData("InvoiceTotal")
                                                            )
                                                        )) ||
                                                    (roundValues &&
                                                        total &&
                                                        Math.round(total).toFixed(2) !==
                                                        parseFloat(
                                                            removeAlphabetsFromString(
                                                                findData("InvoiceTotal")
                                                            )
                                                        ).toFixed(2))) && (
                                                    <div>
                                                        <Popover
                                                            overlayStyle={{width: "400px"}}
                                                            placement="leftBottom"
                                                            onClick={handlePopupClick}
                                                            content={summarycontent}
                                                            title="Error"
                                                            trigger="click"
                                                        >
                                                            <WarningOutlined
                                                                type="exclamation-circle"
                                                                style={{color: "#A4231D", fontSize: "18px"}}
                                                            />
                                                        </Popover>
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    >
                                        <div className="pt-2">
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                {/* CURRENCY */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Currency</span><ConfidenceLabel label={"CurrencyId"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Select
                                                            value={findData("CurrencyId")}
                                                            className="w-full"
                                                            size="middle"
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                (option?.props?.value ?? "").toLowerCase().includes(input.toLowerCase())
                                                            }
                                                            onSelect={(data) => {
                                                                if (companyAllowedCurrencies.length > 0) {
                                                                    const allowedCurrenciesList = companyAllowedCurrencies
                                                                        .map((item, index) => `${index + 1}. ${item.value}`)
                                                                        .join("\n");
                                                                    const currencyMatch = companyAllowedCurrencies.some((item) => item.id === data);
                                                                    if (!currencyMatch) {
                                                                        notification.warning({
                                                                            message: "Warning",
                                                                            description: (
                                                                                <>
                                                                                    <div>Selected Currency {data} does not match Invoice Currency of {findData("CurrencyId")}</div>
                                                                                    <div>Selected Currency of {data} is not permitted for this Supplier</div>
                                                                                    <div>Allowed Currencies:</div>
                                                                                    <div>{allowedCurrenciesList}</div>
                                                                                </>
                                                                            ),
                                                                        });
                                                                    }
                                                                }
                                                                updateDetailData("CurrencyId", data);
                                                            }}
                                                        >
                                                            <OptGroup label={<span className="text-[14px] text-black">Allowed Currencies</span>}>
                                                                {companyAllowedCurrencies && companyAllowedCurrencies.length > 0 ? (
                                                                    companyAllowedCurrencies.map((currency) => (
                                                                        <Option key={currency.value} value={currency.id}>{currency.value}</Option>
                                                                    ))
                                                                ) : (
                                                                    <Option key="no-data" style={{color: "rgba(0,0,0,0.4)"}} value="no-data">No data</Option>
                                                                )}
                                                            </OptGroup>
                                                            <OptGroup label={<span className="text-[14px] text-black">ALL Currencies</span>}>
                                                                {currencyOptions.map((currency) => (
                                                                    <Option key={currency.name} style={{color: "rgba(0,0,0,0.4)"}} value={currency.id}>{currency.name}</Option>
                                                                ))}
                                                            </OptGroup>
                                                        </Select>
                                                    </div>
                                                </div>

                                                {/* SUB TOTAL */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Sub Total</span><ConfidenceLabel label={"SubTotal"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            type="number"
                                                            id="SubTotal"
                                                            className={subTotalClassName()}
                                                            value={removeAlphabetsFromString(findData("SubTotal"))}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* DISCOUNT */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Discount</span><ConfidenceLabel label={"TotalDiscount"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            type="number"
                                                            id="TotalDiscount"
                                                            className={`h-10 border text-right ${borderColor("TotalDiscount")}`}
                                                            value={findData("TotalDiscount")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* TAX RATE */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Tax Rate</span><ConfidenceLabel label={"TaxRate"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            type="number"
                                                            id="TaxRate"
                                                            className={`h-10 border text-right ${borderColor("TaxRate")}`}
                                                            value={removeAlphabetsFromString(findData("TaxRate"))}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* FREIGHT */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Freight</span><ConfidenceLabel label={"Freight"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            type="number"
                                                            id="Freight"
                                                            className={`h-10 border text-right ${borderColor("Freight")}`}
                                                            value={roundValues && findData("Freight") ? Math.round(parseFloat(findData("Freight"))).toFixed(2).toString() : findData("Freight")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* TOTAL TAX */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Total Tax</span><ConfidenceLabel label={"TotalTax"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            type="number"
                                                            id="TotalTax"
                                                            className={`h-10 border text-right ${borderColor("TotalTax")}`}
                                                            value={removeAlphabetsFromString(findData("TotalTax"))}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* PACKAGING */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Packaging</span><ConfidenceLabel label={"Packaging"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <Input
                                                            type="number"
                                                            id="Packaging"
                                                            className={`h-10 border text-right ${borderColor("Packaging")}`}
                                                            value={roundValues && findData("Packaging") ? Math.round(parseFloat(findData("Packaging"))).toFixed(2).toString() : findData("Packaging")}
                                                            onChange={(e, i) => handleInputChange(e, i)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* TOTAL */}
                                                <div>
                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5 flex items-center gap-2"><span>Total</span><ConfidenceLabel label={"InvoiceTotal"} data={invoiceDetailData}/></div>
                                                    <div className="flex">
                                                        <div className={`w-full ${
                                                            !total ||
                                                            (total && roundToDecimalPlaces(total, 2) === parseFloat(removeAlphabetsFromString(findData("InvoiceTotal"))) && findData("InvoiceTotal")) ||
                                                            (roundValues && total && Math.round(total).toFixed(2) === parseFloat(removeAlphabetsFromString(findData("InvoiceTotal"))).toFixed(2))
                                                                ? ""
                                                                : "border border-red-700"
                                                        }`}>
                                                            <Input
                                                                type="number"
                                                                id="InvoiceTotal"
                                                                className={
                                                                    !total ||
                                                                    (total && roundToDecimalPlaces(total, 2) === parseFloat(removeAlphabetsFromString(findData("InvoiceTotal"))) && findData("InvoiceTotal") && findData("SubTotal"))
                                                                        ? `h-10 text-right ${borderColor("InvoiceTotal")}`
                                                                        : "h-10 text-right border"
                                                                }
                                                                value={roundValues && findData("InvoiceTotal") ? Math.round(parseFloat(removeAlphabetsFromString(findData("InvoiceTotal")))).toFixed(2) : removeAlphabetsFromString(findData("InvoiceTotal"))}
                                                                onChange={(e, i) => handleInputChange(e, i)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* PERMITTED ROUNDING */}
                                            <div className="mt-4 pt-3 border-t border-gray-100">
                                                <Checkbox
                                                    checked={roundValues && roundValues !== undefined}
                                                    onChange={(e) => setRoundValues(e.target.checked)}
                                                    disabled
                                                >
                                                    <span className="text-xs text-gray-500">Permit Rounded Values</span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </Panel>
                                </Collapse>
                            </div>

                        <div className="mt-3">
                            <Collapse className="collapse-style">
                                <Panel
                                    header={
                                        <div className="flex items-center gap-2">
                                            <span className="text-black text-[15px] font-normal">Banking</span>
                                            <span className="text-[#7A849A] text-[13px]">· {(ocrBankDetails?.length ?? 0) + (bankDetails?.length ?? 0)}</span>
                                        </div>
                                    }
                                >
                                        {/* From Invoice — blue-tinted section */}
                                        <div
                                            className="rounded-[8px] p-3 mb-3"
                                            style={{borderLeft: "3px solid #1558B0", backgroundColor: "#E6F1FC"}}
                                        >
                                            <div className="flex items-center justify-between mb-3">
                                                <div className="text-[11px] font-semibold tracking-wider" style={{color: "#1558B0"}}>
                                                    FROM INVOICE
                                                </div>
                                                <Tooltip title="Add bank">
                                                    <Button
                                                        type="text"
                                                        size="small"
                                                        icon={<PlusOutlined/>}
                                                        onClick={handleAddBankingOcr}
                                                        style={{color: "#1558B0"}}
                                                    >
                                                        Add bank
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                            {ocrBankDetails && ocrBankDetails.length > 0 ? (
                                                <div className="space-y-3">
                                                    {ocrBankDetails.map((item, index) => (
                                                        <div key={index} className="bg-white rounded-md overflow-hidden border border-[#CFE0F5]">
                                                            <div className="flex items-center justify-between gap-3 px-3 py-2 border-b border-[#E4E7EE]">
                                                                <span className="text-[13px] font-semibold text-[#0B1220] truncate">
                                                                    {[getDescriptionItem(item, "BankName"), getDescriptionItem(item, "BankCurrencyCode")].filter(Boolean).join(" · ") || "New bank"}
                                                                </span>
                                                                <div className="flex items-center gap-2 shrink-0">
                                                                    <Tooltip title="Delete">
                                                                        <DeleteOutlined
                                                                            className="cursor-pointer text-gray-500 hover:text-red-500"
                                                                            onClick={(e) => handleDeleteBankingItem(e, index)}
                                                                        />
                                                                    </Tooltip>
                                                                    <Popover
                                                                        content={() => InvoiceBankValidationmenu(item)}
                                                                        trigger="click"
                                                                        placement="bottomRight"
                                                                        open={invoicePopovers[index]}
                                                                        onOpenChange={(visible) => {
                                                                            const updatedPopovers = [...invoicePopovers];
                                                                            updatedPopovers[index] = visible;
                                                                            setInvoicePopovers(updatedPopovers);
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="cursor-pointer flex items-center text-gray-500"
                                                                            onClick={() => handleSearchInvoiceValidationClick(index)}
                                                                        >
                                                                            {invoiceBankValidationIcons[index] === "NewBank" ||
                                                                            ((item?.InvoiceBankValidationStatus?.value === "NewBank" ||
                                                                                item?.InvoiceBankValidationStatus?.correctedValue === "NewBank") &&
                                                                                invoiceBankValidationIcons[index] !== "DeselectNewBank") ? (
                                                                                <BankOutlined/>
                                                                            ) : (
                                                                                <DownCircleOutlined/>
                                                                            )}
                                                                        </div>
                                                                    </Popover>
                                                                </div>
                                                            </div>
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 px-3 py-3">
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Bank Name</div>
                                                                    <Input id="BankName" value={getDescriptionItem(item, "BankName")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Currency</div>
                                                                    <Input id="BankCurrencyCode" value={getDescriptionItem(item, "BankCurrencyCode")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Account No.</div>
                                                                    <Input id="Accountnumber" value={getDescriptionItem(item, "Accountnumber")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">SWIFT</div>
                                                                    <Input id="SWIFT" value={getDescriptionItem(item, "SWIFT")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">IBAN</div>
                                                                    <Input id="IBAN" value={getDescriptionItem(item, "IBAN")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Sort Code</div>
                                                                    <Input id="SortCode" value={getDescriptionItem(item, "SortCode")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">IFSC</div>
                                                                    <Input id="IFSC" value={getDescriptionItem(item, "IFSC")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                </div>
                                                                {getDescriptionItem(item, "BankAddress") !== undefined && (
                                                                    <div className="col-span-2">
                                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Bank Address</div>
                                                                        <Input id="BankAddress" value={getDescriptionItem(item, "BankAddress")} onChange={(e) => handleInputBankingChange(e, index)}/>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="text-[12px] text-[#1558B0]/70 italic">No bank details on the invoice.</div>
                                            )}
                                        </div>

                                        {/* Supplier registered — green-tinted section */}
                                        <div
                                            className="rounded-[8px] p-3"
                                            style={{borderLeft: "3px solid #1B7A31", backgroundColor: "#ECF9EE"}}
                                        >
                                            <div className="text-[11px] font-semibold tracking-wider mb-3" style={{color: "#1B7A31"}}>
                                                SUPPLIER REGISTERED
                                            </div>
                                            {bankDetails && bankDetails.length > 0 ? (
                                                <div className="space-y-3">
                                                    {bankDetails.map((item, index) => (
                                                        <div key={index} className="bg-white rounded-md overflow-hidden border border-[#C8E9CD]">
                                                            <div className="flex items-center justify-between gap-3 px-3 py-2 border-b border-[#E4E7EE]">
                                                                <span className="text-[13px] font-semibold text-[#0B1220] truncate">
                                                                    {[item.name, item.currencyId].filter(Boolean).join(" · ") || "Bank"}
                                                                </span>
                                                                <Popover
                                                                    content={menu}
                                                                    trigger="click"
                                                                    placement="bottomRight"
                                                                    open={popovers[index]}
                                                                    onOpenChange={(visible) => {
                                                                        const updatedPopovers = [...popovers];
                                                                        updatedPopovers[index] = visible;
                                                                        setPopovers(updatedPopovers);
                                                                    }}
                                                                >
                                                                    {shipsureIcons[index] === "Validated" ||
                                                                    (item?.bankValidation?.bankValidationStatus === "Validated" &&
                                                                        shipsureIcons[index] !== "Unvalidated") ? (
                                                                        <CheckCircleOutlined
                                                                            onClick={() => handleSearchClick(index)}
                                                                            className="cursor-pointer text-[#16a34a] text-[18px]"
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            className="cursor-pointer h-[27.75px] w-[34.75px]"
                                                                            src={BankVerify}
                                                                            onClick={() => handleSearchClick(index)}
                                                                            alt="verify"
                                                                        />
                                                                    )}
                                                                </Popover>
                                                            </div>
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3 px-3 py-3">
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Bank Name</div>
                                                                    <Input value={item.name} disabled/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Currency</div>
                                                                    <Input value={item.currencyId} disabled/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Account No.</div>
                                                                    <Input value={item.accountNumber} disabled/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">SWIFT</div>
                                                                    <Input value={item.swiftCode} disabled/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">IBAN</div>
                                                                    <Input value={item.iban} disabled/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Sort Code</div>
                                                                    <Input value={item.sortCode} disabled/>
                                                                </div>
                                                                <div>
                                                                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">IFSC</div>
                                                                    <Input value={item.ifsc} disabled/>
                                                                </div>
                                                                {item.address && (
                                                                    <div className="col-span-2">
                                                                        <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Bank Address</div>
                                                                        <Input value={item.address} disabled/>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="text-[12px] text-[#1B7A31]/70 italic">No supplier-registered banks.</div>
                                            )}
                                        </div>
                                    </Panel>
                                </Collapse>
                        </div>
                        <div className="mt-3">
                            <Collapse className="collapse-style">
                                <Panel
                                    header={
                                        <div className="flex items-center gap-2">
                                            <span className="text-black text-[15px] font-normal">Supporting Documents</span>
                                            <span className="text-[#7A849A] text-[13px]">· {uploadedAttachments?.length ?? 0}</span>
                                        </div>
                                    }
                                >
                                    <div className="flex flex-col gap-3 p-2">
                                        {uploadedAttachments?.length > 0 && uploadedAttachments.map((item) => (
                                            <AttachmentCard
                                                key={item.id}
                                                attachment={{
                                                    id: item?.id,
                                                    fileName: item?.uploadedFileName,
                                                    size: item?.cloudFileSize,
                                                    type: getFileMimeType(item?.uploadedFiletype)
                                                }}
                                                user={user}
                                                disabled={deleteAttachmentsList.includes(item.id)}
                                                onDelete={handleDeleteList}
                                            />
                                        ))}
                                        <MultiFileUploader
                                            fileList={fileList}
                                            multiple={true}
                                            disabled={selectedItem &&
                                                (selectedItem?.isUploadedToShipsure === true ||
                                                    selectedItem?.processingStatus === ProcessingStatusEnum.Rejected ||
                                                    selectedItem?.processingStatus === ProcessingStatusEnum.InvoiceCreated ||
                                                    selectedItem?.emailValidationQueue?.folder === "reviewedIgnore")
                                            }
                                            onUpload={handleFileUpload}
                                            onChange={handleFileChange}
                                            onRemove={handleRemoveFile}
                                            onReorder={handleReorder}
                                        />
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>
                    </div>
                    <div className="mt-4">
                        <div className="bg-white border border-[#E4E7EE] rounded-[12px] px-4 py-3 flex items-center gap-2 flex-wrap shadow-[0_-8px_24px_-12px_rgba(13,20,35,0.08)]">
                                {selectedItem &&
                                    selectedItem?.isUploadedToShipsure === false &&
                                    selectedItem?.processingStatus !== "Rejected" &&
                                    selectedItem?.processingStatus !== "InvoiceCreated" &&
                                    selectedItem?.emailValidationQueue?.folder !==
                                    "reviewedIgnore" && (
                                        <>
                                            <ActionMenu
                                                loading={loading}
                                                disabled={loading}
                                                menu={<Tooltip title={"Options"}><Button size="small" icon={<EllipsisOutlined/>} type="text"/></Tooltip>}
                                                items={actionItems}/>
                                            <Badge count={selectedItem?.documentNotes?.length ?? 0}
                                                   overflowCount={99}
                                                   showZero={false}>
                                                <Tooltip title={"Comments"}>
                                                    <Button
                                                        size="small"
                                                        onClick={() => setIsCommentModalVisible(true)}
                                                        icon={<CommentOutlined/>}
                                                        type="text"/>
                                                </Tooltip>
                                            </Badge>

                                            <RejectPopUp
                                                emailData={emailData}
                                                isVisible={isPopupVisible}
                                                onClose={handlePopupClose}
                                            />
                                            <DeleteInvoicePopup
                                                selectedItem={selectedItem}
                                                isVisible={isPopupDeleteVisible}
                                                onClose={handlePopupDeleteClose}
                                            />

                                            <div className="flex-1"/>

                                            <Button
                                                onClick={handleDraftClick}
                                                disabled={loading || selectedItem?.isUploadedToShipsure === true || (selectedItem?.isUploadedToShipsure === false && disableSave && updatedDataRef.current.length === 0)}
                                            >
                                                Save draft
                                            </Button>

                                            <Popover
                                                content={
                                                    <>
                                                        {selectedItem?.isUploadedToShipsure === false ? (
                                                            <div className="text-[14px]">
                                                                <div>Please ensure below data is completed:</div>
                                                                <div><strong>Sub Total:</strong> {findData("SubTotal") && (!isConsolidatedDetailLines && !isCrewRecovery ? (amountSum && amountSum !== parseFloat(removeAlphabetsFromString(findData("SubTotal")))) : false) ? "Failed" : "Passed"}</div>
                                                                <div><strong>Invoice Total:</strong> {total && findData("InvoiceTotal") && ((!roundValues && roundToDecimalPlaces(total, 2) !== parseFloat(removeAlphabetsFromString(findData("InvoiceTotal"))))
                                                                    || (roundValues && Math.round(total).toFixed(2) !== parseFloat(removeAlphabetsFromString(findData("InvoiceTotal"))).toFixed(2))) ? "Failed" : "Passed"}</div>
                                                                <div><strong>Pending Changes:</strong> {updatedDataRef.current.length + fileList.length + deleteAttachmentsList.length}</div>
                                                            </div>
                                                        ) : (
                                                            <div className="text-[14px]">No Action-Invoice Created In Shipsure</div>
                                                        )}
                                                    </>
                                                }
                                            >
                                                {!loading ? (
                                                    vesselMgmtBlocked && vesselMgmtInfo && !vesselMgmtInfo.userIsVfc ? (
                                                        <Button
                                                            type="primary"
                                                            onClick={() => notifyVfcForOnHold(vesselMgmtInfo.primaryContact)}
                                                            style={{backgroundColor: "#9B6B00", borderColor: "#9B6B00"}}
                                                        >
                                                            Notify VFC
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            type="primary"
                                                            onClick={
                                                                selectedItem?.isUploadedToShipsure === true
                                                                    ? null
                                                                    : handleSubmitClick
                                                            }
                                                            disabled={submitDisabledCheck()}
                                                        >
                                                            Submit
                                                        </Button>
                                                    )
                                                ) : (
                                                    <Spin
                                                        style={{
                                                            fontSize: "16px",
                                                            opacity: '0.8',
                                                            cursor: 'wait',
                                                            pointerEvents: 'all',
                                                            textDecoration: 'none'
                                                        }}/>
                                                )
                                                }
                                            </Popover>
                                        </>
                                    )}
                                <>
                                    {selectedItem?.isUploadedToShipsure === false &&
                                        selectedItem?.processingStatus === "Rejected" && (
                                            <div className="basis-full w-full rounded-[10px] p-3 flex items-center gap-3"
                                                 style={{backgroundColor: 'var(--primary-color)'}}>
                                                <div className="flex-1 min-w-0 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
                                                    <div>
                                                        <div className="text-[#FFFFFF] text-[13px] font-amina font-bold">
                                                            Invoice Rejected at{" "}
                                                            {formatDate(selectedItem?.rejectedOn, "dd-MMM-yyyy hh:mm tt")}
                                                        </div>
                                                        <div className="text-[#FFFFFF] text-[13px] font-amina mt-2">
                                                            By {selectedItem?.updatedBy}
                                                        </div>
                                                    </div>
                                                    <div className="min-w-0">
                                                        <div className="text-[#FFFFFF] text-[13px] font-amina">
                                                            Reason: {selectedItem?.rejectReason?.name}
                                                        </div>
                                                        <Tooltip title={selectedItem?.comment}>
                                                            <div className="text-[#FFFFFF] text-[13px] font-amina mt-2 truncate">
                                                                Notes: {selectedItem?.comment}
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <Badge count={selectedItem?.documentNotes?.length ?? 0}
                                                       overflowCount={99}
                                                       showZero={false}>
                                                    <Tooltip title={"Comments"}>
                                                        <Button
                                                            className="btn-on-dark"
                                                            onClick={() => setIsCommentModalVisible(true)}
                                                            icon={<CommentOutlined/>}
                                                            type="text"/>
                                                    </Tooltip>
                                                </Badge>
                                            </div>
                                        )}

                                    {(selectedItem?.isUploadedToShipsure || selectedItem?.processingStatus === "InvoiceCreated") && (
                                        <div className="basis-full w-full rounded-[10px] p-3 flex items-center gap-3"
                                             style={{backgroundColor: 'var(--primary-color)'}}>
                                            <div className="flex-1 min-w-0">
                                                <div className="text-[#FFFFFF] text-[13px] font-amina font-bold">
                                                    Shipsure Invoice Generated at{" "}
                                                    {formatDate(selectedItem?.shipsureUploadDateTime ?? selectedItem?.updatedOn)}
                                                </div>
                                                {selectedItem?.shipsureVoucher && (
                                                    <div className="text-[#FFFFFF] text-[13px] font-amina mt-2 font-bold">
                                                        Voucher: {selectedItem?.shipsureVoucher}
                                                    </div>
                                                )}
                                                <div className="text-[#FFFFFF] text-[13px] font-amina mt-2">
                                                    By {selectedItem?.updatedBy}
                                                </div>
                                            </div>
                                            <Badge count={selectedItem?.documentNotes?.length ?? 0}
                                                   overflowCount={99}
                                                   showZero={false}>
                                                <Tooltip title={"Comments"}>
                                                    <Button
                                                        className="btn-on-dark"
                                                        onClick={() => setIsCommentModalVisible(true)}
                                                        icon={<CommentOutlined/>}
                                                        type="text"/>
                                                </Tooltip>
                                            </Badge>
                                        </div>
                                    )}
                                    {selectedItem?.emailValidationQueue?.folder === "reviewedIgnore" && (
                                        <div className="basis-full w-full rounded-[10px] p-3"
                                             style={{backgroundColor: 'var(--primary-color)'}}>
                                            <div className="text-[#FFFFFF] text-[13px] font-amina font-bold">
                                                {selectedItem?.emailValidationQueue?.text}
                                            </div>
                                        </div>
                                    )}
                                </>
                        </div>
                    </div>
                </div>
            </div>
            {
                isUpdateInvoiceModalVisible && (
                    <UpdateInvoiceModal
                        visible={isUpdateInvoiceModalVisible}
                        onCancel={() => setIsUpdateInvoiceModalVisible(false)}
                        status={"InvoiceCreated"}
                        disableStatus={true}
                        documentId={id}
                        user={user}
                    />
                )
            }
            {
                isUpdateInvoiceOnHoldModalVisible && (
                    <UpdateInvoiceModal
                        visible={isUpdateInvoiceOnHoldModalVisible}
                        onCancel={() => setIsUpdateInvoiceOnHoldModalVisible(false)}
                        status={"OnHold"}
                        disableStatus={true}
                        documentId={id}
                        user={user}
                    />
                )
            }
            {
                isReprocessInvoiceModalVisible && (
                    <ReprocessInvoiceModal
                        visible={isReprocessInvoiceModalVisible}
                        onCancel={() => setIsReprocessInvoiceModalVisible(false)}
                        status={"InvoiceCreated"}
                        disableStatus={true}
                        documentId={id}
                        user={user}
                        supplier={supplierDetails}
                    />
                )
            }
            <CommentModal
                visible={isCommentModalVisible}
                onCancel={() => setIsCommentModalVisible(false)}
                disableStatus={true}
                documentId={id}
                user={user}
            />
        </div>
    )
};
export default InvoiceDetail;
